import React, { useEffect, useState, useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import "./Scoring.css";
import VideoJS from "../components/VideoJs";
import { HubConnectionBuilder } from "@microsoft/signalr";
import Button from "react-bootstrap/Button";
import flagService from "../services/FlagService";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Alert from "react-bootstrap/Alert";

import { useSelector } from "react-redux";

import MissingVideoModal from "./Modals/MissingVideoModal";
import PlayerDetailsModal from "./Modals/PlayerDetailsModal";
import MatchEndModal from "./Modals/MatchEndModal";
import FlagModal from "./Modals/FlagModal";
import WatcherCardsMessageModal from "./Modals/WatcherCardsMessageModal";

import scoringService from "../services/ScoringService";
import reviewService from "../services/ReviewService";
import liveRoomService from "../services/LiveRoomService";
import authorizeService from "./api-authorization/AuthorizeService";
import { secondsToTime } from "../utilities/scoringUtilities";
import TeamPitchPositionModal from "./Modals/TeamPitchPositionModal";

import ScoringDetails from "./Scoring/ScoringDetails";
import PitchView from "./Scoring/PitchView";
import InputTable from "./Scoring/InputTable";
import PenaltyShotAtGoal from "./Scoring/PenaltyShotAtGoal";
import TryScore from "./Scoring/TryScore";
import ConversionShotAtGoal from "./Scoring/ConversionShotAtGoal";
import ConversionOrPenaltySetClip from "./Scoring/ConversionOrPenaltySetClip";
import ClipEndPenaltyInfo from "./Scoring/ClipEndPenaltyInfo";
import ClipEndPenaltyInfoUpdate from "./Scoring/ClipEndPenaltyInfoUpdate";
import LineOutInfo from "./Scoring/LineOutInfo";
import LineOutInfoUpdate from "./Scoring/LineOutInfoUpdate";
import ScrumInfo from "./Scoring/ScrumInfo";
import ScrumInfoUpdate from "./Scoring/ScrumInfoUpdate";
import Dropgoal from "./Scoring/Dropgoal";
import TeamScoringControls from "./Scoring/TeamScoringControls";
import ValueScoringControls from "./Scoring/ValueScoringControls";
import CategorizationScoringControls from "./Scoring/CategorizationScoringControls";
import CategorizationBar from "./Scoring/CategorizationBar";
import MultiplePlayersBar from "./Scoring/MultiplePlayersBar";
import PlayerUpdateList from "./Scoring/PlayerUpdateList";

import { ClipState } from "../models/enums/ClipState";
import { MatchEvents } from "../models/enums/MatchEvents";
import { ScoringInputType } from "../models/enums/ScoringInputType";
import { CardType } from "../models/enums/CardType";
import { HalfState } from "../models/enums/HalfState";

import { v4 as uuidv4 } from "uuid";
import categoryService from "../services/CategoryService";
import descriptionService from "../services/DescriptionService";
import UseFullPageLoaderHook from "./Modals/Hook/UseFullPageLoaderHook";

import FutureFixtureValidationPopupModal from "./Modals/FutureFixtureValidationPopupModal";

const Scoring = (props) => {
    const {fixtureRoomId} = useParams();

    const [loading, setLoading] = useState(true);
    const [userRole, setUserRole] = useState(null);
    const [connection, setConnection] = useState(null);

    const [fixtureDetails, setFixtureDetails] = useState(null);
    const [homeTeamPlayers, setHomeTeamPlayers] = useState(null);
    const [awayTeamPlayers, setAwayTeamPlayers] = useState(null);

    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const [selectedScore, setSelectedScore] = useState(null);
    const [selectedCategories, setSelectedCategories] = useState({});
    const [inputItemList, setInputItemList] = useState(null);

    const [currentHalfState, setCurrentHalfState] = useState(
        HalfState.BeforeFirstHalf
    );
    const [firstHalfStart, setFirstHalfStart] = useState(null);
    const [firstHalfEnd, setFirstHalfEnd] = useState(null);
    const [secondHalfStart, setSecondHalfStart] = useState(null);
    const [secondHalfEnd, setSecondHalfEnd] = useState(null);

    const [realMarkerX, setRealMarkerX] = useState(null);
    const [realMarkerY, setRealMarkerY] = useState(null);

    const [clipState, setClipState] = useState(ClipState.NotInClip);
    const [clipStartTime, setClipStartTime] = useState(-1);
    const [startTeam, setStartTeam] = useState(null);
    const [startReason, setStartReason] = useState(null);
    const [clipEndTime, setClipEndTime] = useState(-1);
    const [endTeam, setEndTeam] = useState(null);
    const [endReason, setEndReason] = useState(null);
    const [dropgoalSelected, setDropgoalSelected] = useState(false);

    const [currentClipId, setCurrentClipId] = useState(null);
    const [currentClipNumber, setCurrentClipNumber] = useState(null);

    const [scoreErrorMessages, setScoreErrorMessages] = useState(null);
    const [errorInputIds, setErrorInputIds] = useState(null);

    const [infoMessages, setInfoMessages] = useState(null);

    const [showMissingVideoModal, setShowMissingVideoModal] = useState(false);
    const [showMatchEndModal, setShowMatchEndModal] = useState(false);
    const [showPlayerDetailsModal, setShowPlayerDetailsModal] = useState(false);
    const [videoSource, setVideoSource] = useState(null);

    const [firstHalfTeamAtOrigin, setFirstHalfTeamAtOrigin] = useState(null);
    const [secondHalfTeamAtOrigin, setSecondHalfTeamAtOrigin] = useState(null);
    const [currentTeamAtOrigin, setCurrentTeamAtOrigin] = useState(null);
    const [showTeamPositionsModal, setShowTeamPositionsModal] = useState(false);
    const [isMultipleChoiceForPlayer, setIsMultipleChoiceForPlayer] =
        useState(false);

    const [isMultipleChoiceColor, setIsMultipleChoiceColor] = useState(false);
    const [isConfirmMultipleChoice, setIsConfirmMultipleChoice] = useState(false);
    const [selectedPlayers, setSelectedPlayers] = useState([]);

    const [categoriesList, setCategoriesList] = useState(null);
    const [descriptionOptions, setDescriptionOptions] = useState(null);

    const [inputTime, setInputTime] = useState(null);
    const [selectedDescription, setSelectedDescription] = useState([]);

    const [showFlagModal, setShowFlagModal] = useState(false);
    const [itemBeingFlagged, setItemBeingFlagged] = useState(null);
    const [startHomeOrAwayTeam, setStartHomeOrAwayTeam] = useState(null);
    const [showMultipleSelectedButton, setShowMultipleSelectedButton] =
        useState(true);
    const [showWatcherCardsMessageModal, setShowWatcherCardsMessageModal] =
        useState(false);
    const [isStartSettingClipEnd, setIsStartSettingClipEnd] = useState(false);
    const [isCardHighlighted, setIsCardHighlighted] = useState(false);
    const [selectedPlayersTeam, setSelectedPlayersTeam] = useState({});
    const [isCategoriesListEmpty, setIsCategoriesListEmpty] = useState(false);
    const [isDescriptionListEmpty, setIsDescriptionListEmpty] = useState(false);
    const [isScoresListEmpty, setIsScoresListEmpty] = useState(false);
    const [selectedEditPlayer, setSelectedEditPlayer] = useState(null);
    const [showScoringInputDetailModal, setScoringInputDetailModal] =
        useState(false);
    const [
        showFutureFixtureValidationPopupModal,
        setShowFutureFixtureValidationPopupModal,
    ] = useState(false);
    const [showCreatePlayerDetailsModal, setShowCreatePlayerDetailsModal] =
        useState(false);
    const [isConfirmUpdatePlayer, setIsConfirmUpdatePlayer] = useState(false);
    const [clipSelected, setClipSelected] = useState({});
    const [lineoutEvents, setLineoutEvents] = useState([]);
    const [isWon, setIsWon] = useState(null);
    const [lineoutTarget, setLineoutTarget] = useState(null);
    const [isFreekick, setIsFreekick] = useState(null);
    const [isScrumPenalty, setIsScrumPenalty] = useState(null);
    const [isLineoutClipEnd, setIsLineoutClipEnd] = useState(null);
    const [isScrumClipEnd, setIsScrumClipEnd] = useState(null);
    const [penaltyReason, setPenaltyReason] = useState(null);

    useEffect(() => {
        const categories = async () => {
            categoryService.getCategoriesList().then((categories) => {
                setCategoriesList(categories);
            });
        };

        if (!categoriesList) {
            categories();
        }
    }, []);

    useEffect(() => {
        const description = async () => {
            descriptionService.getScoringDescriptionOptions().then((descriptions) => {
                setDescriptionOptions(descriptions);
            });
        };

        if (!descriptionOptions) {
            description();
        }
    }, []);

    let videoTime = useSelector((state) => state.videoTime);

    let history = useHistory();

    const navigate = (url) => {
        history.push(url);
    };

    const getCurrentTime = (time, inputList) => {
        let clipStates = inputList
            ? inputList.filter(
                (x) =>
                    x.type == ScoringInputType.ClipStart ||
                    x.type == ScoringInputType.ClipEnd
            )
            : [];
        if (clipStates && clipStates.length > 0) {
            let previousClipStarts = clipStates
                .filter((x) => x.type == ScoringInputType.ClipStart && x.time <= time)
                .sort((a, b) => b.time - a.time);

            if (previousClipStarts && previousClipStarts.length > 0) {
                let previousClipStart = previousClipStarts[0];
                if (
                    previousClipStart.hasClipEnd &&
                    previousClipStart.clipEndsAt &&
                    previousClipStart.clipEndsAt >= time
                ) {
                    return {
                        requiresClipEnd: false,
                        isInClip: true,
                        currentClipId: previousClipStart.id,
                        clipNumber: previousClipStart.clipNumber,
                        clipStartReason: previousClipStart.clipStartReason,
                    };
                } else if (!previousClipStart.hasClipEnd) {
                    return {
                        requiresClipEnd: true,
                        isInClip: true,
                        currentClipId: previousClipStart.id,
                        clipNumber: previousClipStart.clipNumber,
                        clipStartReason: previousClipStart.clipStartReason,
                    };
                }
            }
        }

        return {isInClip: false, currentClipId: null};
    };

    const getXAndYCoordinatesBefore = (time, inputList) => {
        let previousList = {};
        let previousClipStartPosition = {};
        if (selectedPlayer?.time) {
            previousList = inputList
                ?.filter((x) => x.time < selectedPlayer.time)
                .reduce(
                    (prev, current) => (prev.time > current.time ? prev : current),
                    1
                );
            previousClipStartPosition = inputList
                ?.filter(
                    (x) =>
                        x.time < selectedPlayer.time &&
                        x.type === ScoringInputType.ClipStart
                )
                .reduce(
                    (prev, current) => (prev.time > current.time ? prev : current),
                    1
                );
        } else {
            previousList = inputList
                ?.filter((x) => x.time < videoTime)
                .reduce(
                    (prev, current) => (prev.time > current.time ? prev : current),
                    1
                );
            previousClipStartPosition = inputList
                ?.filter(
                    (x) => x.time < videoTime && x.type === ScoringInputType.ClipStart
                )
                .reduce(
                    (prev, current) => (prev.time > current.time ? prev : current),
                    1
                );
        }
        if (previousList && previousList !== 1 && previousClipStartPosition !== 1) {
            return {
                positionX: previousList.positionX,
                positionY: previousList.positionY,
                clipStartPositionX: previousClipStartPosition.positionX,
                clipStartPositionY: previousClipStartPosition.positionY,
            };
        }

        return {
            positionX: null,
            positionY: null,
            clipStartPositionX: null,
            clipStartPositionY: null,
        };
    };

    const getCurrentClipFromTime = useMemo(() => {
        return getCurrentTime(videoTime, inputItemList);
    }, [videoTime, inputItemList]);

    const getPreviousXAndYCoordinates = useMemo(() => {
        return getXAndYCoordinatesBefore(videoTime, inputItemList);
    }, [selectedPlayer]);

    const videoPlayerRef = React.useRef(null);
    const videoWrapperRef = React.useRef(null);
    const videoJsRef = React.useRef();

    const videoJsOptions = {
        sources: [
            {
                src: videoSource,
                type: "application/x-mpegURL",
            },
        ],
        controls: true,
        preload: "auto",
        playbackRates: [0.5, 1],
        fluid: true,
        pictureInPictureToggle: true,
        timeDivider: false,
        inactivityTimeout: 0,
    };

    let handlePlayerReady = (player) => {
        videoPlayerRef.current = player;

        player.on("waiting", () => {
            console.log("player is waiting");
        });

        player.on("dispose", () => {
            console.log("player will dispose");
        });
    };

    let onCancelClipButtonClick = async (e) => {
        setActiveClipState(videoTime);
        setShowMultipleSelectedButton(true);
        if (clipState == ClipState.StartClipAndSelectPosition) {
            setClipStartTime(-1);
            setStartReason(null);
            setStartTeam(null);
        } else if (clipState == ClipState.EndClipAndSelectPosition) {
            setClipEndTime(-1);
            setEndReason(null);
            setEndTeam(null);
        }
        setRealMarkerX(null);
        setRealMarkerY(null);
        setClipSelected({});
        setIsWon(null);
        setLineoutTarget(null);
        setIsFreekick(null);
        setIsScrumPenalty(null);
        setIsLineoutClipEnd(false);
        setIsScrumClipEnd(false);
        setPenaltyReason(null);
    };

    let setActiveClipState = (time) => {
        let cur = getCurrentClipFromTime;
        setClipState(
            cur.isInClip && cur.requiresClipEnd
                ? ClipState.InClip
                : ClipState.NotInClip
        );
        if (cur.isInClip) {
            setCurrentClipId(cur.currentClipId);
            setCurrentClipNumber(cur.clipNumber);
        } else {
            setCurrentClipId(null);
            setCurrentClipNumber(null);
        }
    };

    let setActiveHalfState = (time) => {
        if (firstHalfStart == null || time < firstHalfStart) {
            setCurrentHalfState(HalfState.BeforeFirstHalf);
            setCurrentTeamAtOrigin(firstHalfTeamAtOrigin);
        } else if (
            firstHalfStart != null &&
            time >= firstHalfStart &&
            (!firstHalfEnd || time <= firstHalfEnd)
        ) {
            setCurrentHalfState(HalfState.FirstHalf);
            setCurrentTeamAtOrigin(firstHalfTeamAtOrigin);
        } else if (
            firstHalfEnd &&
            time >= firstHalfEnd &&
            (!secondHalfStart || time <= secondHalfStart)
        ) {
            setCurrentHalfState(HalfState.DuringHalfTime);
            setCurrentTeamAtOrigin(secondHalfTeamAtOrigin);
        } else if (
            secondHalfStart &&
            time >= secondHalfStart &&
            (!secondHalfEnd || time <= secondHalfEnd)
        ) {
            setCurrentHalfState(HalfState.SecondHalf);
            setCurrentTeamAtOrigin(secondHalfTeamAtOrigin);
        } else if (secondHalfEnd && time >= secondHalfEnd) {
            setCurrentHalfState(HalfState.AfterSecondHalf);
            setCurrentTeamAtOrigin(secondHalfTeamAtOrigin);
        }
    };

    let handleVideoTimeChange = (time) => {
        if (
            clipState != ClipState.StartClipAndSelectPosition &&
            clipState != ClipState.EndClipAndSelectPosition
        ) {
            setActiveClipState(time);
            setActiveHalfState(time);
        }
    };

    let playerDetailsModal = fixtureDetails ? (
        <PlayerDetailsModal
            onHide={() => setShowPlayerDetailsModal(false)}
            show={showPlayerDetailsModal}
            fixtureDetails={fixtureDetails}
            setIsConfirmUpdatePlayer={setIsConfirmUpdatePlayer}
        />
    ) : null;

    let videoControls =
        videoSource && videoSource.length > 0 ? (
            <Col>
                <VideoJS
                    ref={videoJsRef}
                    options={videoJsOptions}
                    onReady={handlePlayerReady}
                    height={"calc(100vh - 40vh)"}
                    maxHeight={"calc(100vh - 40vh)"}
                    isModalOpen={showFlagModal || showScoringInputDetailModal}
                />
            </Col>
        ) : (
            <></>
        );

    const hideMatchEndModal = () => {
        setShowMatchEndModal(false);
        props.history.push(`/liverooms`);
    };

    const hideMissingVideoModal = () => {
        setShowMissingVideoModal(false);
        props.history.push(`/liverooms`);
    };

    const hideFutureFixturePopupModal = () => {
        setShowFutureFixtureValidationPopupModal(false);
        props.history.push(`/liverooms`);
    };

    const hideTeamPitchPositionModal = () => {
        setShowTeamPositionsModal(false);
    };

    const hideFlagModal = () => {
        setShowFlagModal(false);
        setItemBeingFlagged(null);
    };

    const hideWatcherCardsMessageModal = () => {
        setShowWatcherCardsMessageModal(false);
    };

    const onShowWatcherCardsMessageModal = () => {
        setShowWatcherCardsMessageModal(true);
    };

    const isCreatePlayerDetailModalDisplayed = (
        firstHalfTeamAtOrigin,
        isPlayerDetailModified,
        isTrackedByAPI,
        isForTraining
    ) => {
        if (
            !firstHalfTeamAtOrigin &&
            !isPlayerDetailModified &&
            !isTrackedByAPI &&
            !isForTraining
        ) {
            setShowCreatePlayerDetailsModal(true);
        }
    };

    const onFlagClick = (type, id) => {
        if (
            type != ScoringInputType.FirstHalfStart &&
            type != ScoringInputType.SecondHalfStart &&
            type != ScoringInputType.FirstHalfEnd &&
            type != ScoringInputType.SecondHalfEnd
        ) {
            const matchedItems = inputItemList.filter(
                (x) => x.id == id && x.type == type
            );
            if (matchedItems && matchedItems.length > 0) {
                setItemBeingFlagged(matchedItems[0]);
                setShowFlagModal(true);
            }
        }
    };

    const [loader, showLoader, hideLoader] = UseFullPageLoaderHook();

    useEffect(() => {
        handleVideoTimeChange(videoTime);
    }, [videoTime]);

    useEffect(() => {
        const scoring = async () => {
            scoringService.getScoringDetails(fixtureRoomId).then((details) => {
                setFixtureDetails(details);
                if (!details.videoUrl || details.videoUrl == "")
                    setShowMissingVideoModal(true);
                else if (Date.parse(details.date) > Date.parse(new Date()))
                    setShowFutureFixtureValidationPopupModal(true);
                else {
                    setHomeTeamPlayers([
                        {
                            id: details.homeTeam.id,
                            key: details.homeTeam.abbreviation + " Team",
                            teamId: details.homeTeam.id,
                        },
                        ...details.homeTeamPlayers,
                    ]);
                    setAwayTeamPlayers([
                        {
                            id: details.awayTeam.id,
                            key: details.awayTeam.abbreviation + " Team",
                            teamId: details.awayTeam.id,
                        },
                        ...details.awayTeamPlayers,
                    ]);
                    setFirstHalfStart(details.firstHalfStart);
                    setFirstHalfEnd(details.firstHalfEnd);
                    setSecondHalfStart(details.secondHalfStart);
                    setSecondHalfEnd(details.secondHalfEnd);
                    setVideoSource(details.videoUrl);
                    setFirstHalfTeamAtOrigin(details.firstHalfTeamAtOrigin);
                    setSecondHalfTeamAtOrigin(details.secondHalfTeamAtOrigin);
                    setStartHomeOrAwayTeam(details.startTeam);
                    isCreatePlayerDetailModalDisplayed(
                        details.firstHalfTeamAtOrigin,
                        details.isPlayerDetailModified,
                        details.isTrackedByAPI,
                        details.isForTraining
                    );
                    setLineoutEvents([
                        MatchEvents.Lineout,
                        MatchEvents.QuickLineout,
                        MatchEvents.ThreeManLineout,
                        MatchEvents.FourManLineout,
                        MatchEvents.FiveManLineout,
                        MatchEvents.SixManLineout,
                        MatchEvents.SevenManLineout,
                        MatchEvents.EightPlusManLineout,
                    ]);
                }
                setLoading(false);
            });
        };

        if (
            (!fixtureDetails && !isCardHighlighted && !isConfirmUpdatePlayer) ||
            isCardHighlighted ||
            isConfirmUpdatePlayer
        ) {
            scoring();
            setIsCardHighlighted(false);
            setIsConfirmUpdatePlayer(false);
        }
    }, [fixtureDetails, fixtureRoomId, isCardHighlighted, isConfirmUpdatePlayer]);

    useEffect(() => {
        const scoring = async () => {
            scoringService.getInputItemList(fixtureRoomId).then((result) => {
                setInputItemList(result);
            });
        };

        if (fixtureRoomId) {
            scoring();
        }
    }, [fixtureRoomId]);

    useEffect(() => {
        const auth = async () => {
            authorizeService.getUserRole().then((role) => {
                setUserRole(role);
            });
        };

        if (!userRole) {
            auth();
        }
    }, []);

    useEffect(() => {
        let getUrl = window.location;
        let baseUrl = getUrl.protocol + "//" + getUrl.host;

        const connection = new HubConnectionBuilder()
            .withUrl(`${baseUrl}/hubs/fixturerooms`, {
                accessTokenFactory: () => authorizeService.getAccessToken(),
            })
            .withAutomaticReconnect()
            .build();

        setConnection(connection);
    }, []);

    useEffect(() => {
        const connect = async () => {
            connection
                .start()
                .then((res) => {
                    connection.invoke("JoinRoom", fixtureRoomId).catch((err) => {
                        console.log(err);
                        props.history.push(`/livematches`);
                    });
                })
                .catch((err) => {
                    console.log(err);
                })
                .then((result) => {
                    console.log("Connected!");

                    connection.on("RoomEnd", (message) => {
                        setShowMatchEndModal(true);
                    });

                    connection.on("PlayerScoreChange", (message) => {
                        setHomeTeamPlayers(message.homeTeamPlayers);
                        setAwayTeamPlayers(message.awayTeamPlayers);
                    });

                    connection.on("InputListUpdate", (message) => {
                        setInputItemList(message.inputList);

                        setFirstHalfStart(message.firstHalfStart);
                        setFirstHalfEnd(message.firstHalfEnd);
                        setSecondHalfStart(message.secondHalfStart);
                        setSecondHalfEnd(message.secondHalfEnd);

                        setActiveClipState(videoTime);
                    });

                    connection.on("HalfTimesChange", (message) => {
                        setFirstHalfStart(message.firstHalfStart);
                        setFirstHalfEnd(message.firstHalfEnd);
                        setSecondHalfStart(message.secondHalfStart);
                        setSecondHalfEnd(message.secondHalfEnd);
                    });

                    connection.on("TeamPitchOriginsUpdated", (message) => {
                        setFirstHalfTeamAtOrigin(message.firstHalfTeamAtOrigin);
                        setSecondHalfTeamAtOrigin(message.secondHalfTeamAtOrigin);
                    });
                })
                .catch((e) => console.log("Connection failed: ", e));
        };
        if (connection) {
            connect();
        }
    }, [connection]);

    const listVideoTimeScoredOutside = (inputItemList, videoTime) => {
        let cur = getCurrentTime(videoTime, inputItemList);
        if (!cur.isInClip || (cur.isInClip && cur.requiresClipEnd)) {
            let inputListWithOutsideScoring = inputItemList.filter(
                (x) =>
                    (!getCurrentTime(x.time, inputItemList).isInClip ||
                        (getCurrentTime(x.time, inputItemList).isInClip &&
                            getCurrentTime(x.time, inputItemList).requiresClipEnd)) &&
                    (x.type === ScoringInputType.PlayerScore ||
                        x.type === ScoringInputType.YellowCard ||
                        x.type === ScoringInputType.RedCard ||
                        x.type === ScoringInputType.YellowCardReturned)
            );
            let listVideoTimeOutSide = [];
            if (inputListWithOutsideScoring.length > 0) {
                for (let i = 0; i < inputListWithOutsideScoring.length; i++) {
                    listVideoTimeOutSide.push({
                        key: videoTime,
                        time: secondsToTime(videoTime),
                    });
                    listVideoTimeOutSide.push({
                        key: inputListWithOutsideScoring[i].time,
                        time: secondsToTime(inputListWithOutsideScoring[i].time),
                    });
                    listVideoTimeOutSide.sort((a, b) => a.key - b.key);
                }
            } else {
                listVideoTimeOutSide.push({
                    key: videoTime,
                    time: secondsToTime(videoTime),
                });
            }
            setScoreErrorMessages([
                {
                    id: uuidv4(),
                    text:
                        "Scores are outside clip at " +
                        Array.from(new Set(listVideoTimeOutSide.map((e) => e.time))).join(
                            ","
                        ),
                },
            ]);
        }
    };

    const setClip = async (
        clipId,
        markerX,
        markerY,
        clipType,
        teamId,
        clipSelectedPlayer,
        isWonOrLost,
        lineoutTargetResult,
        isFreekickResult,
        isPenaltyResult,
        penaltyReasonResult
    ) => {
        try {
            showLoader();
            await scoringService.setClipEvent(
                clipId,
                markerX,
                markerY,
                clipType,
                clipSelectedPlayer,
                teamId,
                isWonOrLost,
                lineoutTargetResult,
                isFreekickResult,
                isPenaltyResult,
                penaltyReasonResult
            );
            setClipSelected({});
            setPenaltyReason(null);
            hideLoader();
        } catch (err) {
            hideLoader();
            console.log(err);
            err && err.data
                ? setScoreErrorMessages([
                    {
                        id: uuidv4(),
                        text: err.data.error ? err.data.error : err.data,
                    },
                ])
                : setScoreErrorMessages([{id: uuidv4(), text: "An error occurred"}]);
        }
    };

    const setPlayerScore = async (
        playerScoreId,
        teamId,
        updatePlayerId,
        positionX,
        positionY,
        scoreValue,
        categories,
        descriptions,
        isTeamScore
    ) => {
        try {

            positionX = realMarkerX ? realMarkerX : positionX;
            positionY = realMarkerY ? realMarkerY : positionY;
            categories =
                Object.keys(selectedCategories).length > 0
                    ? selectedCategories
                    : categories;
            descriptions =
                Object.keys(selectedDescription || {}).length > 0
                    ? selectedDescription
                    : !selectedDescription || !descriptions
                        ? []
                        : descriptions.map((x) => ({
                            id: x.descriptionId,
                            descriptions: x.description,
                        }));
            scoreValue = selectedScore ? selectedScore.value : scoreValue;

            updatePlayerId = updatePlayerId
                ? updatePlayerId
                : selectedPlayer?.shirtNumber;

            let mappedCategorizations = [];
            let mappedDescriptions = [];
            Object.keys(categories)
                .filter((key) => categories[key] > 0)
                .map((key, index) => {
                    mappedCategorizations.push({
                        key: Number(key),
                        value: categories[key],
                    });
                });
            if (Object.keys(descriptions || {}).length > 0) {
                mappedDescriptions = [
                    {
                        ...descriptions,
                        id: descriptions.id,
                        descriptions: descriptions.descriptions,
                    },
                ];
            }
            await scoringService.setPlayerScore(
                playerScoreId,
                teamId,
                updatePlayerId,
                positionX,
                positionY,
                scoreValue,
                mappedCategorizations,
                mappedDescriptions,
                fixtureRoomId,
                isTeamScore
            );
        } catch (err) {
            err && err.data
                ? setScoreErrorMessages([
                    {
                        id: uuidv4(),
                        text: err.data.error ? err.data.error : err.data,
                    },
                ])
                : setScoreErrorMessages([{id: uuidv4(), text: "An error occurred"}]);
        }
    };

    const savePlayerScore = async (
        fixtureId,
        teamId,
        position,
        scoreValue,
        selectedCategories,
        selectedDescription,
    ) => {
        try {
            let mappedCategorizations = [];
            Object.keys(selectedCategories)
                .filter((key) => selectedCategories[key] > 0)
                .map((key, index) => {
                    mappedCategorizations.push({
                        key: Number(key),
                        value: selectedCategories[key],
                    });
                });
            let mappedDescriptions = [];
            if (Object.keys(selectedDescription || {}).length > 0) {
                mappedDescriptions.push(selectedDescription);
            } else {
                mappedDescriptions = selectedDescription;
            }
            await scoringService.addScore(
                fixtureId,
                teamId,
                position,
                scoreValue,
                mappedCategorizations,
                currentHalfState,
                videoTime,
                realMarkerX,
                realMarkerY,
                mappedDescriptions,
                selectedPlayer.shirtNumber
            );
            listVideoTimeScoredOutside(inputItemList, videoTime);
        } catch (err) {
            err && err.data
                ? setScoreErrorMessages([
                    {
                        id: uuidv4(),
                        text: err.data.error ? err.data.error : err.data,
                    },
                ])
                : setScoreErrorMessages([{id: uuidv4(), text: "An error occurred"}]);
        }
    };

    const savePlayerScoreGroup = async (
        fixtureRoomId,
        selectedPlayers,
        scoreValue,
        selectedCategories,
        selectedDescription,
        videoTime
    ) => {
        try {
            let mappedCategorizations = [];
            Object.keys(selectedCategories)
                .filter((key) => selectedCategories[key] > 0)
                .map((key, index) => {
                    mappedCategorizations.push({
                        key: Number(key),
                        value: selectedCategories[key],
                    });
                });
            let mappedDescriptions = [];

            if (Object.keys(selectedDescription || {}).length > 0) {
                mappedDescriptions.push(selectedDescription);
            } else {
                mappedDescriptions = selectedDescription;
            }
            await scoringService.addGroupScore(
                fixtureRoomId,
                selectedPlayers,
                scoreValue,
                mappedCategorizations,
                currentHalfState,
                videoTime,
                realMarkerX,
                realMarkerY,
                mappedDescriptions
            );
            listVideoTimeScoredOutside(inputItemList, videoTime);
        } catch (err) {
            err && err.data
                ? setScoreErrorMessages([
                    {
                        id: uuidv4(),
                        text: err.data.error ? err.data.error : err.data,
                    },
                ])
                : setScoreErrorMessages([{id: uuidv4(), text: "An error occurred"}]);
        }
    };

    const saveTeamScore = async (
        fixtureRoomId,
        teamId,
        position,
        scoreValue,
        selectedCategories,
        selectedDescription
    ) => {
        if (getCurrentClipFromTime.isInClip) {
            let mappedCategorizations = [];
            Object.keys(selectedCategories)
                .filter((key) => selectedCategories[key] > 0)
                .map((key, index) => {
                    mappedCategorizations.push({
                        key: Number(key),
                        value: selectedCategories[key],
                    });
                });
            let mappedDescriptions = [];

            if (Object.keys(selectedDescription || {}).length > 0) {
                mappedDescriptions.push(selectedDescription);
            } else {
                mappedDescriptions = selectedDescription;
            }

            await scoringService.addTeamScore(
                fixtureRoomId,
                teamId,
                position,
                scoreValue,
                mappedCategorizations,
                currentHalfState,
                videoTime,
                realMarkerX,
                realMarkerY,
                mappedDescriptions
            );
        } else {
            setScoreErrorMessages([
                {id: uuidv4(), text: "Please add scores within a clip"},
            ]);
        }
    };

    const handleEndFirstHalf = async (time) => {
        if (
            clipState == ClipState.NotInClip &&
            currentHalfState == HalfState.FirstHalf &&
            currentClipId == null
        ) {
            await scoringService.setFirstHalfEnd(fixtureRoomId, time);
        }
    };

    const handleEndSecondHalf = async (time) => {
        if (
            clipState == ClipState.NotInClip &&
            currentHalfState == HalfState.SecondHalf &&
            currentClipId == null
        ) {
            await scoringService.setSecondHalfEnd(fixtureRoomId, time);
        }
    };

    const handleStartClipClick = async (restartTeam, restartReason) => {
        setShowMultipleSelectedButton(false);

        if (!firstHalfTeamAtOrigin || !secondHalfTeamAtOrigin) {
            setShowTeamPositionsModal(true);
        } else {
            if (clipState == ClipState.NotInClip) {
                let cur = getCurrentClipFromTime;
                if (cur.isInClip) {
                    setScoreErrorMessages([
                        {id: uuidv4(), text: "Cannot start new clip within a clip"},
                    ]);
                    setShowMultipleSelectedButton(true);
                } else {
                    setClipStartTime(videoTime);
                    videoJsRef.current.pauseVideo();
                    setStartTeam(restartTeam);
                    setStartReason(restartReason);
                    setClipState(ClipState.StartClipAndSelectPosition);
                }
            }
        }
    };

    const startClipWithSameAsEnd = async () => {
        if (clipState == ClipState.NotInClip) {
            let cur = getCurrentClipFromTime;
            if (cur.isInClip) {
                setScoreErrorMessages([
                    {id: uuidv4(), text: "Cannot start new clip within a clip"},
                ]);
            } else {
                setClipStartTime(videoTime);
                videoJsRef.current.pauseVideo();

                let clipEnds = inputItemList
                    ? inputItemList.filter((x) => x.type == ScoringInputType.ClipEnd)
                    : [];
                if (clipEnds && clipEnds.length > 0) {
                    clipEnds = clipEnds.filter((x) => x.time <= videoTime);
                    let lastClipEnd = clipEnds[clipEnds.length - 1];

                    if (lastClipEnd.clipEndReason > 10) {
                        setScoreErrorMessages([
                            {
                                id: uuidv4(),
                                text: `Cannot start new clip with ${lastClipEnd.clipEndReason} (from last clip end)`,
                            },
                        ]);
                    } else {
                        const newClip = await scoringService.startNewClip(
                            fixtureRoomId,
                            currentHalfState,
                            videoTime,
                            lastClipEnd.teamId,
                            lastClipEnd.clipEndReason,
                            lastClipEnd.positionX,
                            lastClipEnd.positionY
                        );
                        setCurrentClipId(newClip.clipId);

                        setClipState(ClipState.InClip);

                        setStartTeam(null);
                        setStartReason(null);
                        setClipStartTime(-1);
                    }
                } else {
                    setScoreErrorMessages([
                        {
                            id: uuidv4(),
                            text: "Cannot start new clip same as end when there is no previous clips",
                        },
                    ]);
                }
            }
        }
    };

    const handleEndClipClick = async (endTeam, endReason) => {
        setShowMultipleSelectedButton(false);
        if (clipState == ClipState.InClip) {
            //progress to next clip state
            setClipEndTime(videoTime);
            videoJsRef.current.pauseVideo();
            setEndTeam(endTeam);
            setEndReason(endReason);
            setClipState(ClipState.EndClipAndSelectPosition);
        }
    };

    const handleClipActionInSpecificEvent = async (matchEvent) => {
        const newClip = await scoringService.startNewClipWithWatcherInfo(
            fixtureRoomId,
            videoTime,
            startTeam,
            startReason,
            previousClipEnd().positionX,
            previousClipEnd().positionY
        );
        setClipState(ClipState.StartClipAndSelectPosition);
        setCurrentClipId(newClip);

        if (matchEvent == MatchEvents.Lineout) {
            setIsLineoutClipEnd(true);
        } else {
            setIsScrumClipEnd(true);
        }

        setShowMultipleSelectedButton(true);
    };

    const handleClipActionClick = async () => {
        if (
            clipState == ClipState.StartClipAndSelectPosition &&
            clipStartTime > -1
        ) {
            if (
                (realMarkerX != null &&
                    realMarkerX >= 0 &&
                    realMarkerY != null &&
                    realMarkerY >= 0) ||
                (previousClipEnd()?.endTeam &&
                    startReason !== MatchEvents.Kickoff &&
                    startReason !== MatchEvents.TwentyTwo &&
                    !lineoutEvents.includes(startReason) &&
                    startReason !== MatchEvents.Scrum)
            ) {
                if (
                    !previousClipEnd().endTeam ||
                    startReason == MatchEvents.TwentyTwo ||
                    previousClipEnd().clipEndReason === MatchEvents.ShotAtGoalPenaltyMiss
                ) {
                    const newClip = await scoringService.startNewClip(
                        fixtureRoomId,
                        videoTime,
                        startTeam,
                        startReason,
                        realMarkerX,
                        realMarkerY
                    );
                    setCurrentClipId(newClip);
                } else {
                    const newClip = await scoringService.startNewClip(
                        fixtureRoomId,
                        videoTime,
                        startTeam,
                        startReason,
                        previousClipEnd().positionX,
                        previousClipEnd().positionY
                    );
                    setCurrentClipId(newClip);
                }
                setClipState(ClipState.InClip);
                setRealMarkerX(null);
                setRealMarkerY(null);

                setStartTeam(null);
                setStartReason(null);
                setClipStartTime(-1);
            } else if (lineoutEvents.includes(startReason)) {
                handleClipActionInSpecificEvent(MatchEvents.Lineout);
            } else if (startReason == MatchEvents.Scrum) {
                handleClipActionInSpecificEvent(MatchEvents.Scrum);
            } else if (startReason == MatchEvents.Kickoff) {
                setShowMultipleSelectedButton(true);
                const newClip = await scoringService.startNewClip(
                    fixtureRoomId,
                    videoTime,
                    startTeam,
                    startReason,
                    50,
                    35
                );
                setCurrentClipId(newClip);
                setClipState(ClipState.InClip);
            } else {
                setScoreErrorMessages([
                    {id: uuidv4(), text: "Please set clip start cordinates"},
                ]);
            }
        } else if (
            clipState == ClipState.EndClipAndSelectPosition &&
            clipEndTime > -1
        ) {
            if (
                realMarkerX != null &&
                realMarkerX >= 0 &&
                realMarkerY != null &&
                realMarkerY >= 0
            ) {
                let penaltyReasonResult =
                    endReason === MatchEvents.Penalty ? penaltyReason : null;
                setScoreErrorMessages(null);
                setShowMultipleSelectedButton(true);
                await scoringService.endClip(
                    currentClipId,
                    clipEndTime,
                    endTeam,
                    endReason,
                    realMarkerX,
                    realMarkerY,
                    penaltyReasonResult
                );
                setCurrentClipId(null);
                setRealMarkerX(null);
                setRealMarkerY(null);
                setEndTeam(null);
                setEndReason(null);
                setClipEndTime(-1);
                setClipState(ClipState.NotInClip);
            } else {
                setScoreErrorMessages([
                    {id: uuidv4(), text: "Please set clip end coordinates"},
                ]);
            }
        }
    };

    const handleSelectMultipleButton = () => {
        setSelectedPlayersTeam({});
        setIsMultipleChoiceForPlayer((current) => !current);
        setSelectedPlayers([]);
        setIsMultipleChoiceColor(false);
        setIsConfirmMultipleChoice(false);
    };

    const handleConfirmMultipleChoice = () => {
        if (isConfirmMultipleChoice) {
            setSelectedPlayers([]);
            setSelectedPlayersTeam({});
        } else {
            setSelectedScore(null);
            setRealMarkerX(null);
            setRealMarkerY(null);
            setSelectedCategories({});
        }
        setIsConfirmMultipleChoice((current) => !current);
        setIsMultipleChoiceColor(false);
    };

    const handleRealMarkerX = (x) => {
        setRealMarkerX(x);
    };

    const handleRealMarkerY = (y) => {
        setRealMarkerY(y);
    };

    let selectedString =
        (selectedPlayer ? selectedPlayer.key : "") +
        (selectedPlayer && selectedScore
            ? selectedScore.text
            : selectedPlayer?.categorizations
                ? selectedPlayer.scoreText
                : "");

    let selectedMultipleString =
        (isMultipleChoiceForPlayer
            ? Array.from(new Set(selectedPlayers.map((e) => e.key))).join(",")
            : "") +
        (isMultipleChoiceForPlayer && selectedScore && selectedPlayers.length > 0
            ? selectedScore.text
            : "");

    const getScoreErrorMessageSpan = () => {
        if (scoreErrorMessages && scoreErrorMessages.length > 0) {
            let result = [];

            for (let i = 0; i < scoreErrorMessages.length; i++) {
                let current = scoreErrorMessages[i];
                result.push(
                    <Alert
                        key={current.id}
                        variant="danger"
                        className="text-center my-1"
                        onClose={() => {
                            setScoreErrorMessages(
                                scoreErrorMessages && scoreErrorMessages.length > 0
                                    ? scoreErrorMessages.filter((x) => x.id != current.id)
                                    : null
                            );
                            setErrorInputIds(
                                errorInputIds && errorInputIds.length > 0
                                    ? errorInputIds.filter((x) => x != current.id)
                                    : null
                            );
                        }}
                        dismissible
                    >
            <span>
              {current.text?.error ? current.text?.error : current.text}
            </span>
                    </Alert>
                );
            }

            return (
                <div
                    className="mb-1"
                    style={{maxHeight: "240px", overflowY: "scroll"}}
                >
                    {result}
                </div>
            );
        }
    };

    const getInfoMessageSpan = () => {
        if (infoMessages && infoMessages.length > 0) {
            let result = [];

            for (let i = 0; i < infoMessages.length; i++) {
                let current = infoMessages[i];
                result.push(
                    <Alert
                        key={current.id}
                        variant="info"
                        className="text-center my-1"
                        onClose={() =>
                            setInfoMessages(infoMessages.filter((x) => x.id != current.id))
                        }
                        dismissible
                    >
                        <span>{current.text}</span>
                    </Alert>
                );
            }

            return (
                <div
                    className="mb-1"
                    style={{maxHeight: "240px", overflowY: "scroll"}}
                >
                    {result}
                </div>
            );
        }
    };

    const scoreErrorMessageSpan = getScoreErrorMessageSpan();
    const infoMessageSpan = getInfoMessageSpan();

    const deleteAction = async (type, id) => {
        if (
            type == ScoringInputType.FirstHalfStart ||
            type == ScoringInputType.SecondHalfStart
        ) {
            await scoringService.deleteHalfStart(
                fixtureRoomId,
                type == ScoringInputType.FirstHalfStart ? 1 : 2
            );
            type == ScoringInputType.FirstHalfStart
                ? setFirstHalfStart(null)
                : setSecondHalfStart(null);
        } else if (
            type == ScoringInputType.FirstHalfEnd ||
            type == ScoringInputType.SecondHalfEnd
        ) {
            await scoringService.deleteHalfEnd(
                fixtureRoomId,
                type == ScoringInputType.FirstHalfEnd ? 1 : 2
            );
        } else if (
            type == ScoringInputType.ClipStart ||
            type == ScoringInputType.ClipEnd
        ) {
            await scoringService.deleteClip(
                fixtureRoomId,
                id,
                type == ScoringInputType.ClipEnd
            );
        } else if (type == ScoringInputType.PlayerScore) {
            await scoringService.deleteScore(fixtureRoomId, id);
        } else if (type == ScoringInputType.YellowCard) {
            await scoringService.deleteCard(
                fixtureRoomId,
                id,
                ScoringInputType.YellowCard
            );
        } else if (type == ScoringInputType.RedCard) {
            await scoringService.deleteCard(
                fixtureRoomId,
                id,
                ScoringInputType.RedCard
            );
        } else if (type == ScoringInputType.TeamScore) {
            await scoringService.deleteTeamScore(fixtureRoomId, id);
        } else if (type == ScoringInputType.YellowCardReturned) {
            await scoringService.deleteCard(
                fixtureRoomId,
                id,
                ScoringInputType.YellowCardReturned
            );
        } else if (type == ScoringInputType.RedCardReturned) {
            await scoringService.deleteCard(
                fixtureRoomId,
                id,
                ScoringInputType.RedCardReturned
            );
        } else if (type == ScoringInputType.Try) {
            await scoringService.deleteTryScorer(id);
        } else if (type == ScoringInputType.RefDecision) {
            await flagService.deleteFlag(id);
        }
    };

    let FutureFixturePopupModal = (
        <FutureFixtureValidationPopupModal
            onHide={hideFutureFixturePopupModal}
            show={showFutureFixtureValidationPopupModal}
        ></FutureFixtureValidationPopupModal>
    );

    let missingVideoModal = fixtureDetails ? (
        <MissingVideoModal
            onHide={hideMissingVideoModal}
            show={showMissingVideoModal}
            fixtureId={fixtureDetails.fixtureId}
        ></MissingVideoModal>
    ) : (
        <></>
    );

    let matchEndModal = (
        <MatchEndModal
            onHide={hideMatchEndModal}
            show={showMatchEndModal}
        ></MatchEndModal>
    );

    let teamPitchPositionModal =
        fixtureDetails && !loading ? (
            <TeamPitchPositionModal
                onHide={hideTeamPitchPositionModal}
                show={showTeamPositionsModal}
                homeTeam={fixtureDetails.homeTeam}
                awayTeam={fixtureDetails.awayTeam}
                firstHalfTeam={firstHalfTeamAtOrigin}
                secondHalfTeam={secondHalfTeamAtOrigin}
                fixtureRoomId={fixtureRoomId}
            ></TeamPitchPositionModal>
        ) : (
            <></>
        );

    let flagModal =
        fixtureDetails && !loading ? (
            <FlagModal
                onHide={hideFlagModal}
                show={showFlagModal}
                inputItem={itemBeingFlagged}
                fixtureRoomId={fixtureRoomId}
            ></FlagModal>
        ) : (
            <></>
        );

    let watcherCardsMessageModal =
        fixtureDetails && !loading ? (
            <WatcherCardsMessageModal
                onHide={hideWatcherCardsMessageModal}
                onShow={onShowWatcherCardsMessageModal}
                show={showWatcherCardsMessageModal}
                setSelectedPlayer={setSelectedPlayer}
                selectedPlayer={selectedPlayer}
                fixtureRoomId={fixtureRoomId}
                videoTime={videoTime}
                setIsCardHighlighted={setIsCardHighlighted}
                inputItemList={inputItemList}
            ></WatcherCardsMessageModal>
        ) : (
            <></>
        );

    const previousClipEnd = () => {
        let clipEnds = inputItemList
            ? inputItemList.filter((x) => x.type == ScoringInputType.ClipEnd)
            : [];
        let clipStarts = inputItemList
            ? inputItemList.filter((x) => x.type == ScoringInputType.ClipStart)
            : [];
        if (clipEnds && clipEnds.length > 0) {
            clipEnds = clipEnds.filter((x) => x.time <= videoTime);
            clipStarts = clipStarts.filter((x) => x.time <= videoTime);
            if (clipEnds && clipEnds.length > 0) {
                if (
                    videoTime >= firstHalfEnd &&
                    firstHalfEnd !== null &&
                    secondHalfStart == null
                ) {
                    return {
                        endTeam: clipStarts[0].teamId,
                        clipEndsAt: clipStarts[0].clipEndsAt,
                        clipEndReason: clipStarts[0].clipEndReason,
                        positionX: clipStarts[0].positionX,
                        positionY: clipStarts[0].positionY,
                    };
                } else if (
                    !firstHalfEnd ||
                    secondHalfStart ||
                    firstHalfEnd > 0 ||
                    secondHalfStart > 0
                ) {
                    return {
                        endTeam: clipEnds[clipEnds.length - 1].teamId,
                        clipEndsAt: clipEnds[clipEnds.length - 1].clipEndsAt,
                        clipEndReason: clipEnds[clipEnds.length - 1].clipEndReason,
                        positionX: clipEnds[clipEnds.length - 1].positionX,
                        positionY: clipEnds[clipEnds.length - 1].positionY,
                    };
                }
            }
        }
        return null;
    };

    const previousClipEndXCoordinate = () => {
        let clipEnds = inputItemList
            ? inputItemList.filter((x) => x.type == ScoringInputType.ClipEnd)
            : [];
        if (clipEnds && clipEnds.length > 0) {
            clipEnds = clipEnds.filter((x) => x.time <= videoTime);
            if (clipEnds && clipEnds.length > 0) {
                return clipEnds[clipEnds.length - 1].positionX;
            }
        }
        return null;
    };

    const previousClipEndYCoordinate = () => {
        let clipEnds = inputItemList
            ? inputItemList.filter((x) => x.type == ScoringInputType.ClipEnd)
            : [];
        if (clipEnds && clipEnds.length > 0) {
            clipEnds = clipEnds.filter((x) => x.time <= videoTime);
            if (clipEnds && clipEnds.length > 0) {
                return clipEnds[clipEnds.length - 1].positionY;
            }
        }
        return null;
    };

    const currentClipStartReason = () => {
        let cur = getCurrentClipFromTime;
        if (cur.clipNumber >= 1) {
            return cur.clipStartReason;
        }
    };

    const previousClipEndReason = () => {
        let clipEnds = inputItemList
            ? inputItemList.filter((x) => x.type == ScoringInputType.ClipEnd)
            : [];
        if (clipEnds && clipEnds.length > 0) {
            clipEnds = clipEnds.filter((x) => x.time <= videoTime);
            if (clipEnds && clipEnds.length > 0) {
                return clipEnds[clipEnds.length - 1].clipEndReason;
            }
        }
        return null;
    };

    const previousClipEndTeam = () => {
        let clipEnds = inputItemList
            ? inputItemList.filter((x) => x.type == ScoringInputType.ClipEnd)
            : [];
        if (clipEnds && clipEnds.length > 0) {
            clipEnds = clipEnds.filter((x) => x.time <= videoTime);
            if (clipEnds && clipEnds.length > 0) {
                return clipEnds[clipEnds.length - 1].teamId;
            }
        }
        return null;
    };

    const disableHomeButton = () => {
        if (previousClipEndReason() == MatchEvents.Try) {
            if (previousClipEndTeam() == fixtureDetails.homeTeam.id) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    };

    const handleConfirmLineout = async () => {
        if (videoTime <= clipStartTime) {
            setScoreErrorMessages([
                {
                    id: uuidv4(),
                    text: "Lineout information result must come after clip start",
                },
            ]);
        } else {
            if (lineoutTarget == null) {
                setScoreErrorMessages([
                    {id: uuidv4(), text: "Please select a target"},
                ]);
            } else {
                await scoringService.addLineOutInfo(
                    currentClipId,
                    isWon,
                    lineoutTarget,
                    isFreekick
                );
                setIsWon(null);
                setLineoutTarget(null);
                setIsFreekick(null);
                setIsLineoutClipEnd(false);
                setClipState(ClipState.InClip);
                setScoreErrorMessages(null);
            }
        }
    };

    const handleConfirmScrum = async () => {
        if (videoTime <= clipStartTime) {
            setScoreErrorMessages([
                {
                    id: uuidv4(),
                    text: "Scrum information result must come after clip start",
                },
            ]);
        } else {
            if (isWon == null) {
                setScoreErrorMessages([
                    {id: uuidv4(), text: "Please select a won or lost outcome"},
                ]);
            } else {
                await scoringService.addScrumInfo(
                    currentClipId,
                    isWon,
                    isScrumPenalty,
                    isFreekick
                );
                setIsWon(null);
                setIsFreekick(null);
                setIsScrumPenalty(null);
                setIsScrumClipEnd(false);
                setClipState(ClipState.InClip);
                setScoreErrorMessages(null);
            }
        }
    };

    const onComponentClose = () => {
        setRealMarkerX(null);
        setRealMarkerY(null);
        setDropgoalSelected(false);
        setSelectedPlayer(null);
    };

    const displayKickInfo = () => {
        setInfoMessages([
            {id: uuidv4(), text: "Please check supremacy following dropgoal"},
        ]);
    };

    const getStartReasonByEndReason = (teamId, isTheClipStartWithTheOpposite) => {
        const matchEventPreviousClipEnd = [
            MatchEvents.ShotAtGoalConversionSuccess,
            MatchEvents.ShotAtGoalConversionMiss,
            MatchEvents.ShotAtGoalPenaltySuccess,
            MatchEvents.DropgoalSuccess,
            MatchEvents.PenaltyTry,
            MatchEvents.DropgoalMiss,
            MatchEvents.ShotAtGoalPenaltyMiss,
        ];
        const isInMatchEvent = matchEventPreviousClipEnd.includes(
            previousClipEnd()?.clipEndReason
        );
        const isSameTeam = previousClipEnd()?.endTeam === teamId;

        if (isTheClipStartWithTheOpposite) {
            if (
                startHomeOrAwayTeam === teamId &&
                firstHalfStart > 0 &&
                !firstHalfEnd &&
                !secondHalfStart &&
                isSameTeam &&
                isInMatchEvent
            )
                return true;
            if (previousClipEnd()?.endTeam) {
                if (secondHalfStart || secondHalfEnd) {
                    if (
                        videoTime < secondHalfEnd ||
                        videoTime >= secondHalfStart ||
                        videoTime < firstHalfEnd
                    )
                        return isSameTeam ? isInMatchEvent : !isInMatchEvent;
                    return true;
                }

                if (firstHalfEnd) {
                    if (videoTime < firstHalfEnd)
                        return isSameTeam ? isInMatchEvent : !isInMatchEvent;
                    return !isSameTeam ? isInMatchEvent : !isInMatchEvent;
                }

                return isSameTeam ? isInMatchEvent : !isInMatchEvent;
            }
        } else if (isSameTeam) {
            return true;
        }
        return false;
    };

    let inputTableHeightOffset =
        (videoWrapperRef && videoWrapperRef.current
            ? videoWrapperRef.current.clientHeight
            : 0) + 85;
    return (
        <div
            style={{
                overflowX: "hidden",
                overflowY: "scroll",
                height: "calc(100vh - 65px)",
            }}
        >
            <Row>
                <Col
                    lg="4"
                    md="5"
                    className="pl-4"
                    style={{
                        backgroundColor: "#e9ecef",
                        overflowY: "auto",
                        height: "calc(100vh - 65px)",
                    }}
                >
                    <ScoringDetails
                        fixtureDetails={fixtureDetails}
                        inputItemList={inputItemList}
                        currentClipNumber={currentClipNumber}
                        currentHalfState={currentHalfState}
                    />
                    <Row className="mt-1">
                        <Col>
                            <Button
                                className=""
                                variant="outline-primary"
                                size="sm"
                                onClick={async (e) => {
                                    reviewService
                                        .validateRoom(fixtureRoomId)
                                        .then((result) => {
                                            if (!result.isValid && result.errors) {
                                                setScoreErrorMessages(result.errors);
                                                setErrorInputIds(result.errors.map((x) => x.id));
                                            } else {
                                                setScoreErrorMessages(null);
                                                setErrorInputIds(null);
                                                setInfoMessages([
                                                    {id: uuidv4(), text: "Room is valid"},
                                                ]);
                                            }
                                        });
                                }}
                            >
                                Validate Room
                            </Button>
                            <Button
                                className="mx-1"
                                variant="outline-primary"
                                size="sm"
                                onClick={async (e) => {
                                    reviewService
                                        .validateRoom(fixtureRoomId)
                                        .then((result) => {
                                            if (!result.isValid && result.errors) {
                                                setScoreErrorMessages(result.errors);
                                                setErrorInputIds(result.errors.map((x) => x.id));
                                            } else {
                                                navigate(`/scoring/${fixtureRoomId}/review`);
                                            }
                                        });
                                }}
                            >
                                Review
                            </Button>
                            <Button
                                className=""
                                variant="outline-secondary"
                                size="sm"
                                onClick={async (e) => {
                                    setShowPlayerDetailsModal(true);
                                    setIsCardHighlighted(true);
                                }}
                            >
                                Player Details
                            </Button>
                            <Button
                                className="ml-1"
                                variant="outline-secondary"
                                size="sm"
                                onClick={async (e) => {
                                    setShowTeamPositionsModal(true);
                                }}
                            >
                                Team Pitch Positions
                            </Button>
                        </Col>
                    </Row>

                    <hr></hr>

                    <div className="d-flex mt-1">
                        <div className="d-flex flex-fill">
                            {clipState == ClipState.NotInClip &&
                                fixtureDetails &&
                                !selectedPlayer &&
                                Object.keys(clipSelected).length < 1 && (
                                    <>
                                        {getStartReasonByEndReason(
                                            fixtureDetails.homeTeam?.id,
                                            true
                                        ) ? (
                                            <></>
                                        ) : getStartReasonByEndReason(
                                            fixtureDetails.homeTeam?.id,
                                            false
                                        ) ? (
                                            <DropdownButton
                                                title={fixtureDetails.homeTeam?.abbreviation + " Start"}
                                                variant="outline-primary"
                                                className=""
                                                size="sm"
                                                onClick={() => {
                                                    setIsStartSettingClipEnd(false);
                                                    previousClipEnd();
                                                }}
                                            >
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.Lineout && (
                                                        <>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.homeTeam.id,
                                                                        MatchEvents.QuickLineout
                                                                    );
                                                                }}
                                                            >
                                                                Quick Lineout
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.homeTeam.id,
                                                                        MatchEvents.ThreeManLineout
                                                                    );
                                                                }}
                                                            >
                                                                3 Man Lineout{" "}
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.homeTeam.id,
                                                                        MatchEvents.FourManLineout
                                                                    );
                                                                }}
                                                            >
                                                                4 Man Lineout{" "}
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.homeTeam.id,
                                                                        MatchEvents.FiveManLineout
                                                                    );
                                                                }}
                                                            >
                                                                5 Man Lineout{" "}
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.homeTeam.id,
                                                                        MatchEvents.SixManLineout
                                                                    );
                                                                }}
                                                            >
                                                                6 Man Lineout{" "}
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.homeTeam.id,
                                                                        MatchEvents.SevenManLineout
                                                                    );
                                                                }}
                                                            >
                                                                7 Man Lineout
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.homeTeam.id,
                                                                        MatchEvents.EightPlusManLineout
                                                                    );
                                                                }}
                                                            >
                                                                8+ Man Lineout
                                                            </Dropdown.Item>
                                                        </>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.PenaltyTry && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.homeTeam.id,
                                                                    MatchEvents.Kickoff
                                                                );
                                                            }}
                                                        >
                                                            Kick off
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.ShotAtGoalConversionSuccess && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.homeTeam.id,
                                                                    MatchEvents.Kickoff
                                                                );
                                                            }}
                                                        >
                                                            Kick off
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.ShotAtGoalConversionMiss && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.homeTeam.id,
                                                                    MatchEvents.Kickoff
                                                                );
                                                            }}
                                                        >
                                                            Kick off
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.ShotAtGoalPenaltySuccess && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.homeTeam.id,
                                                                    MatchEvents.Kickoff
                                                                );
                                                            }}
                                                        >
                                                            Kick off
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.Scrum && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.homeTeam.id,
                                                                    MatchEvents.Scrum
                                                                );
                                                            }}
                                                        >
                                                            Scrum
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.TwentyTwo && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.homeTeam.id,
                                                                    MatchEvents.TwentyTwo
                                                                );
                                                                await setIsStartSettingClipEnd(true);
                                                            }}
                                                        >
                                                            22
                                                        </Dropdown.Item>
                                                    )}

                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.GoalLineDropOut && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.homeTeam.id,
                                                                    MatchEvents.GoalLineDropOut
                                                                );
                                                            }}
                                                        >
                                                            Goal line drop out
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.FreeKick && (
                                                        <>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.homeTeam.id,
                                                                        MatchEvents.Scrum
                                                                    );
                                                                }}
                                                            >
                                                                Scrum
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.homeTeam.id,
                                                                        MatchEvents.FreeKick
                                                                    );
                                                                }}
                                                            >
                                                                Free kick
                                                            </Dropdown.Item>
                                                        </>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.DropgoalSuccess && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.homeTeam.id,
                                                                    MatchEvents.Kickoff
                                                                );
                                                            }}
                                                        >
                                                            Kick off
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.ShotAtGoalPenalty && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.homeTeam.id,
                                                                    MatchEvents.ShotAtGoalPenalty
                                                                );
                                                            }}
                                                        >
                                                            Shot at goal (Penalty)
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.Penalty && (
                                                        <>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.homeTeam.id,
                                                                        MatchEvents.ShotAtGoalPenalty
                                                                    );
                                                                }}
                                                            >
                                                                Shot at goal (Penalty)
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.homeTeam.id,
                                                                        MatchEvents.PenaltyKickForTouch
                                                                    );
                                                                }}
                                                            >
                                                                Penalty kick for touch
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.homeTeam.id,
                                                                        MatchEvents.PenaltyTapAndGo
                                                                    );
                                                                }}
                                                            >
                                                                Penalty tap and go
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.homeTeam.id,
                                                                        MatchEvents.Scrum
                                                                    );
                                                                }}
                                                            >
                                                                Scrum
                                                            </Dropdown.Item>
                                                        </>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.Try && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.homeTeam.id,
                                                                    MatchEvents.ShotAtGoalConversion
                                                                );
                                                                await setIsStartSettingClipEnd(true);
                                                            }}
                                                        >
                                                            Shot at goal (Conversion)
                                                        </Dropdown.Item>
                                                    )}
                                            </DropdownButton>
                                        ) : (
                                            <DropdownButton
                                                title={fixtureDetails.homeTeam?.abbreviation + " Start"}
                                                variant="outline-primary"
                                                className=""
                                                size="sm"
                                                onClick={async () => {
                                                    setIsStartSettingClipEnd(false);
                                                    await previousClipEndReason();
                                                }}
                                            >
                                                {previousClipEnd()?.clipEndReason ==
                                                MatchEvents.DropgoalMiss ||
                                                previousClipEnd()?.clipEndReason ==
                                                MatchEvents.ShotAtGoalPenaltyMiss ? (
                                                    <Dropdown.Item
                                                        onClick={async () => {
                                                            await handleStartClipClick(
                                                                fixtureDetails.homeTeam.id,
                                                                MatchEvents.TwentyTwo
                                                            );
                                                            setIsStartSettingClipEnd(true);
                                                        }}
                                                    >
                                                        22
                                                    </Dropdown.Item>
                                                ) : (
                                                    <Dropdown.Item
                                                        onClick={async () => {
                                                            await handleStartClipClick(
                                                                fixtureDetails.homeTeam.id,
                                                                MatchEvents.Kickoff
                                                            );
                                                        }}
                                                    >
                                                        Kickoff
                                                    </Dropdown.Item>
                                                )}
                                            </DropdownButton>
                                        )}
                                        {getStartReasonByEndReason(
                                            fixtureDetails.awayTeam?.id,
                                            true
                                        ) ? (
                                            <></>
                                        ) : getStartReasonByEndReason(
                                            fixtureDetails.awayTeam?.id,
                                            false
                                        ) ? (
                                            <DropdownButton
                                                title={fixtureDetails.awayTeam?.abbreviation + " Start"}
                                                variant="outline-primary"
                                                className="ml-2"
                                                size="sm"
                                                onClick={async () => {
                                                    await setIsStartSettingClipEnd(false);
                                                    await previousClipEnd();
                                                }}
                                            >
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.Lineout && (
                                                        <>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.awayTeam.id,
                                                                        MatchEvents.QuickLineout
                                                                    );
                                                                }}
                                                            >
                                                                Quick Lineout
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.awayTeam.id,
                                                                        MatchEvents.ThreeManLineout
                                                                    );
                                                                }}
                                                            >
                                                                3 Man Lineout{" "}
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.awayTeam.id,
                                                                        MatchEvents.FourManLineout
                                                                    );
                                                                }}
                                                            >
                                                                4 Man Lineout{" "}
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.awayTeam.id,
                                                                        MatchEvents.FiveManLineout
                                                                    );
                                                                }}
                                                            >
                                                                5 Man Lineout{" "}
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.awayTeam.id,
                                                                        MatchEvents.SixManLineout
                                                                    );
                                                                }}
                                                            >
                                                                6 Man Lineout{" "}
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.awayTeam.id,
                                                                        MatchEvents.SevenManLineout
                                                                    );
                                                                }}
                                                            >
                                                                7 Man Lineout
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.awayTeam.id,
                                                                        MatchEvents.EightPlusManLineout
                                                                    );
                                                                }}
                                                            >
                                                                8+ Man Lineout
                                                            </Dropdown.Item>
                                                        </>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.PenaltyTry && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.awayTeam.id,
                                                                    MatchEvents.Kickoff
                                                                );
                                                            }}
                                                        >
                                                            Kick off
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.ShotAtGoalConversionSuccess && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.awayTeam.id,
                                                                    MatchEvents.Kickoff
                                                                );
                                                            }}
                                                        >
                                                            Kick off
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.ShotAtGoalConversionMiss && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.awayTeam.id,
                                                                    MatchEvents.Kickoff
                                                                );
                                                            }}
                                                        >
                                                            Kick off
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.ShotAtGoalPenaltySuccess && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.awayTeam.id,
                                                                    MatchEvents.Kickoff
                                                                );
                                                            }}
                                                        >
                                                            Kick off
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.Scrum && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.awayTeam.id,
                                                                    MatchEvents.Scrum
                                                                );
                                                            }}
                                                        >
                                                            Scrum
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.TwentyTwo && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.awayTeam.id,
                                                                    MatchEvents.TwentyTwo
                                                                );
                                                                await setIsStartSettingClipEnd(true);
                                                            }}
                                                        >
                                                            22
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.GoalLineDropOut && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.awayTeam.id,
                                                                    MatchEvents.GoalLineDropOut
                                                                );
                                                            }}
                                                        >
                                                            Goal line drop out
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.FreeKick && (
                                                        <>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.awayTeam.id,
                                                                        MatchEvents.Scrum
                                                                    );
                                                                }}
                                                            >
                                                                Scrum
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.awayTeam.id,
                                                                        MatchEvents.FreeKick
                                                                    );
                                                                }}
                                                            >
                                                                Free kick
                                                            </Dropdown.Item>
                                                        </>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.ShotAtGoalPenalty && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.awayTeam.id,
                                                                    MatchEvents.ShotAtGoalPenalty
                                                                );
                                                            }}
                                                        >
                                                            Shot at goal (Penalty)
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.Penalty && (
                                                        <>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.awayTeam.id,
                                                                        MatchEvents.ShotAtGoalPenalty
                                                                    );
                                                                }}
                                                            >
                                                                Shot at goal (Penalty)
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.awayTeam.id,
                                                                        MatchEvents.PenaltyKickForTouch
                                                                    );
                                                                }}
                                                            >
                                                                Penalty kick for touch
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.awayTeam.id,
                                                                        MatchEvents.PenaltyTapAndGo
                                                                    );
                                                                }}
                                                            >
                                                                Penalty tap and go
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await handleStartClipClick(
                                                                        fixtureDetails.awayTeam.id,
                                                                        MatchEvents.Scrum
                                                                    );
                                                                }}
                                                            >
                                                                Scrum
                                                            </Dropdown.Item>
                                                        </>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ==
                                                    MatchEvents.DropgoalSuccess && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.awayTeam.id,
                                                                    MatchEvents.Kickoff
                                                                );
                                                            }}
                                                        >
                                                            Kick off
                                                        </Dropdown.Item>
                                                    )}
                                                {previousClipEnd()?.clipEndReason ===
                                                    MatchEvents.Try && (
                                                        <Dropdown.Item
                                                            onClick={async () => {
                                                                await handleStartClipClick(
                                                                    fixtureDetails.awayTeam.id,
                                                                    MatchEvents.ShotAtGoalConversion
                                                                );
                                                                setIsStartSettingClipEnd(true);
                                                            }}
                                                        >
                                                            Shot at goal (Conversion)
                                                        </Dropdown.Item>
                                                    )}
                                            </DropdownButton>
                                        ) : (
                                            <DropdownButton
                                                title={fixtureDetails.awayTeam?.abbreviation + " Start"}
                                                variant="outline-primary"
                                                className="ml-2"
                                                size="sm"
                                                onClick={async () => {
                                                    setIsStartSettingClipEnd(false);
                                                    previousClipEnd();
                                                }}
                                            >
                                                {previousClipEnd()?.clipEndReason ==
                                                MatchEvents.DropgoalMiss ||
                                                previousClipEnd()?.clipEndReason ==
                                                MatchEvents.ShotAtGoalPenaltyMiss ? (
                                                    <Dropdown.Item
                                                        onClick={async () => {
                                                            await handleStartClipClick(
                                                                fixtureDetails.awayTeam.id,
                                                                MatchEvents.TwentyTwo
                                                            );
                                                            await setIsStartSettingClipEnd(true);
                                                        }}
                                                    >
                                                        22
                                                    </Dropdown.Item>
                                                ) : (
                                                    <Dropdown.Item
                                                        onClick={async () => {
                                                            await handleStartClipClick(
                                                                fixtureDetails.awayTeam.id,
                                                                MatchEvents.Kickoff
                                                            );
                                                        }}
                                                    >
                                                        Kickoff
                                                    </Dropdown.Item>
                                                )}
                                            </DropdownButton>
                                        )}
                                    </>
                                )}

                            {clipState == ClipState.NotInClip &&
                                fixtureDetails &&
                                inputItemList &&
                                inputItemList.filter((x) => x.type == ScoringInputType.EndClip)
                                    .length > 0 &&
                                videoTime >
                                inputItemList.filter(
                                    (x) => x.type == ScoringInputType.EndClip
                                )[0].time && (
                                    <Button
                                        variant="outline-primary"
                                        className="ml-2"
                                        size="sm"
                                        onClick={async () => {
                                            await startClipWithSameAsEnd();
                                        }}
                                    >
                                        Start same as last end
                                    </Button>
                                )}

                            {clipState == ClipState.InClip &&
                                !selectedPlayer &&
                                Object.keys(clipSelected).length < 1 && (
                                    <>
                                        <DropdownButton
                                            title={fixtureDetails.homeTeam?.abbreviation + " End"}
                                            variant="outline-primary"
                                            className="ml-2"
                                            size="sm"
                                            onClick={async () => {
                                                setIsStartSettingClipEnd(true);
                                            }}
                                        >
                                            <Dropdown.Item
                                                onClick={async () => {
                                                    await handleEndClipClick(
                                                        fixtureDetails.homeTeam.id,
                                                        MatchEvents.Lineout
                                                    );
                                                }}
                                            >
                                                Lineout
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={async () => {
                                                    await handleEndClipClick(
                                                        fixtureDetails.homeTeam.id,
                                                        MatchEvents.Scrum
                                                    );
                                                }}
                                            >
                                                Scrum
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={async () => {
                                                    await handleEndClipClick(
                                                        fixtureDetails.homeTeam.id,
                                                        MatchEvents.TwentyTwo
                                                    );
                                                }}
                                            >
                                                22
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={async () => {
                                                    await handleEndClipClick(
                                                        fixtureDetails.homeTeam.id,
                                                        MatchEvents.GoalLineDropOut
                                                    );
                                                }}
                                            >
                                                Goal line drop out
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={async () => {
                                                    await handleEndClipClick(
                                                        fixtureDetails.homeTeam.id,
                                                        MatchEvents.FreeKick
                                                    );
                                                }}
                                            >
                                                Free kick
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={async () => {
                                                    await handleEndClipClick(
                                                        fixtureDetails.homeTeam.id,
                                                        MatchEvents.Penalty
                                                    );
                                                }}
                                            >
                                                Penalty
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={async () => {
                                                    await handleEndClipClick(
                                                        fixtureDetails.homeTeam.id,
                                                        MatchEvents.Try
                                                    );
                                                }}
                                            >
                                                Try
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={async () => {
                                                    await handleEndClipClick(
                                                        fixtureDetails.homeTeam.id,
                                                        MatchEvents.PenaltyTry
                                                    );
                                                }}
                                            >
                                                Penalty Try
                                            </Dropdown.Item>
                                            {currentClipStartReason() ==
                                                MatchEvents.ShotAtGoalConversion && (
                                                    <Dropdown.Item
                                                        onClick={async () => {
                                                            await handleEndClipClick(
                                                                fixtureDetails.homeTeam.id,
                                                                MatchEvents.ShotAtGoalConversion
                                                            );
                                                        }}
                                                    >
                                                        Shot at goal (Conversion)
                                                    </Dropdown.Item>
                                                )}
                                        </DropdownButton>
                                        <DropdownButton
                                            title={fixtureDetails.awayTeam?.abbreviation + " End"}
                                            variant="outline-primary"
                                            className="ml-2"
                                            size="sm"
                                            onClick={async () => {
                                                setIsStartSettingClipEnd(true);
                                            }}
                                        >
                                            <Dropdown.Item
                                                onClick={async () => {
                                                    await handleEndClipClick(
                                                        fixtureDetails.awayTeam.id,
                                                        MatchEvents.Lineout
                                                    );
                                                }}
                                            >
                                                Lineout
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={async () => {
                                                    await handleEndClipClick(
                                                        fixtureDetails.awayTeam.id,
                                                        MatchEvents.Scrum
                                                    );
                                                }}
                                            >
                                                Scrum
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={async () => {
                                                    await handleEndClipClick(
                                                        fixtureDetails.awayTeam.id,
                                                        MatchEvents.TwentyTwo
                                                    );
                                                }}
                                            >
                                                22
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={async () => {
                                                    await handleEndClipClick(
                                                        fixtureDetails.awayTeam.id,
                                                        MatchEvents.GoalLineDropOut
                                                    );
                                                }}
                                            >
                                                Goal line drop out
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={async () => {
                                                    await handleEndClipClick(
                                                        fixtureDetails.awayTeam.id,
                                                        MatchEvents.FreeKick
                                                    );
                                                }}
                                            >
                                                Free kick
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={async () => {
                                                    await handleEndClipClick(
                                                        fixtureDetails.awayTeam.id,
                                                        MatchEvents.Penalty
                                                    );
                                                }}
                                            >
                                                Penalty
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={async () => {
                                                    await handleEndClipClick(
                                                        fixtureDetails.awayTeam.id,
                                                        MatchEvents.Try
                                                    );
                                                }}
                                            >
                                                Try
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={async () => {
                                                    await handleEndClipClick(
                                                        fixtureDetails.awayTeam.id,
                                                        MatchEvents.PenaltyTry
                                                    );
                                                }}
                                            >
                                                Penalty Try
                                            </Dropdown.Item>
                                            {currentClipStartReason() ==
                                                MatchEvents.ShotAtGoalConversion && (
                                                    <Dropdown.Item
                                                        onClick={async () => {
                                                            await handleEndClipClick(
                                                                fixtureDetails.awayTeam.id,
                                                                MatchEvents.ShotAtGoalConversion
                                                            );
                                                        }}
                                                    >
                                                        Shot at goal (Conversion)
                                                    </Dropdown.Item>
                                                )}
                                        </DropdownButton>
                                    </>
                                )}
                            {fixtureDetails &&
                            !(
                                clipState == ClipState.StartClipAndSelectPosition ||
                                clipState == ClipState.EndClipAndSelectPosition
                            ) ? (
                                showMultipleSelectedButton &&
                                !selectedPlayer &&
                                Object.keys(clipSelected).length < 1 ? (
                                    <Button
                                        variant="outline-primary"
                                        className="ml-2"
                                        size="sm"
                                        style={{
                                            backgroundColor: isMultipleChoiceForPlayer
                                                ? "#007BFF"
                                                : "",
                                            color: isMultipleChoiceForPlayer ? "white" : "",
                                        }}
                                        onClick={handleSelectMultipleButton}
                                    >
                                        Select Multiple
                                    </Button>
                                ) : (
                                    <></>
                                )
                            ) : (
                                <></>
                            )}

                            {isMultipleChoiceForPlayer ? (
                                <Button
                                    variant="outline-success"
                                    className="ml-2"
                                    size="sm"
                                    style={{
                                        backgroundColor: isConfirmMultipleChoice ? "#007BFF" : "",
                                        color: isConfirmMultipleChoice ? "white" : "",
                                    }}
                                    disabled={!selectedPlayers.length}
                                    onClick={handleConfirmMultipleChoice}
                                >
                                    Confirm Multiple
                                </Button>
                            ) : (
                                <></>
                            )}

                            {currentClipId == null &&
                                previousClipEndReason() != MatchEvents.Try &&
                                clipState == ClipState.NotInClip &&
                                currentHalfState == HalfState.FirstHalf &&
                                !selectedPlayer &&
                                Object.keys(clipSelected).length < 1 && (
                                    <Button
                                        variant="outline-primary"
                                        className="ml-2"
                                        size="sm"
                                        onClick={async () => {
                                            handleEndFirstHalf(videoTime);
                                        }}
                                    >
                                        End 1st half
                                    </Button>
                                )}

                            {currentClipId == null &&
                                previousClipEndReason() != MatchEvents.Try &&
                                clipState == ClipState.NotInClip &&
                                currentHalfState == HalfState.SecondHalf &&
                                !selectedPlayer &&
                                Object.keys(clipSelected).length < 1 && (
                                    <Button
                                        variant="outline-primary"
                                        className="ml-2"
                                        size="sm"
                                        onClick={async () => {
                                            handleEndSecondHalf(videoTime);
                                        }}
                                    >
                                        End 2nd half
                                    </Button>
                                )}
                        </div>
                        <div className="d-flex flex-fill justify-content-end align-items-end">
                            {selectedPlayer &&
                                selectedPlayer.position != -1 &&
                                !selectedPlayer?.categorizations && (
                                    <>
                                        <Button
                                            className="ml-1"
                                            variant={dropgoalSelected ? "primary" : "outline-primary"}
                                            size="sm"
                                            disabled={clipState == ClipState.InClip ? false : true}
                                            onClick={async (e) => {
                                                dropgoalSelected
                                                    ? setDropgoalSelected(false)
                                                    : setDropgoalSelected(true);
                                                videoJsRef.current.pauseVideo();
                                            }}
                                        >
                                            Dropgoal
                                        </Button>
                                        {!inputItemList?.some(
                                            (x) =>
                                                x.playerScoreKey === selectedPlayer?.key &&
                                                x.time > videoTime &&
                                                (x.type === ScoringInputType.YellowCard ||
                                                    x.type === ScoringInputType.RedCard)
                                        ) && (
                                            <>
                                                <Button
                                                    className="ml-1"
                                                    variant="outline-warning"
                                                    size="sm"
                                                    onClick={async () => {
                                                        try {
                                                            showLoader();
                                                            await scoringService.addCardScore(
                                                                fixtureRoomId,
                                                                selectedPlayer.teamId,
                                                                selectedPlayer.position,
                                                                CardType.YellowCard,
                                                                videoTime,
                                                                null,
                                                                selectedPlayer.shirtNumber
                                                            );
                                                            listVideoTimeScoredOutside(
                                                                inputItemList,
                                                                videoTime
                                                            );
                                                            setIsCardHighlighted(true);
                                                            setSelectedPlayer(null);
                                                            hideLoader();
                                                        } catch (err) {
                                                            hideLoader();
                                                            if (err && err.data && err.data.error) {
                                                                setScoreErrorMessages([
                                                                    {
                                                                        id: uuidv4(),
                                                                        text: err.data?.error
                                                                            ? err.data.error
                                                                            : err.data,
                                                                    },
                                                                ]);
                                                            } else {
                                                                setScoreErrorMessages([
                                                                    {
                                                                        id: uuidv4(),
                                                                        text: "An error occured",
                                                                    },
                                                                ]);
                                                            }
                                                        }
                                                    }}
                                                >
                                                    Yellow Card
                                                </Button>
                                            </>
                                        )}
                                        {!inputItemList?.some(
                                            (x) =>
                                                x.playerScoreKey === selectedPlayer?.key &&
                                                x.time > videoTime &&
                                                (x.type === ScoringInputType.YellowCard ||
                                                    x.type === ScoringInputType.RedCard)
                                        ) && (
                                            <>
                                                <Button
                                                    className="ml-1"
                                                    variant="outline-danger"
                                                    size="sm"
                                                    onClick={async () => {
                                                        try {
                                                            showLoader();
                                                            await scoringService.addCardScore(
                                                                fixtureRoomId,
                                                                selectedPlayer.teamId,
                                                                selectedPlayer.position,
                                                                CardType.RedCard,
                                                                videoTime,
                                                                null,
                                                                selectedPlayer.shirtNumber
                                                            );
                                                            setIsCardHighlighted(true);
                                                            setSelectedPlayer(null);
                                                            listVideoTimeScoredOutside(
                                                                inputItemList,
                                                                videoTime
                                                            );
                                                            hideLoader();
                                                        } catch (err) {
                                                            hideLoader();
                                                            if (err && err.data && err.data.error) {
                                                                setScoreErrorMessages([
                                                                    {
                                                                        id: uuidv4(),
                                                                        text: err.data?.error
                                                                            ? err.data.error
                                                                            : err.data,
                                                                    },
                                                                ]);
                                                            } else {
                                                                setScoreErrorMessages([
                                                                    {
                                                                        id: uuidv4(),
                                                                        text: "An error occured",
                                                                    },
                                                                ]);
                                                            }
                                                        }
                                                    }}
                                                >
                                                    Red Card
                                                </Button>
                                            </>
                                        )}
                                    </>
                                )}
                        </div>

                        {((clipState == ClipState.StartClipAndSelectPosition &&
                                startReason !== MatchEvents.Kickoff) ||
                            clipState == ClipState.EndClipAndSelectPosition) && (
                            <>
                                {clipState == ClipState.StartClipAndSelectPosition &&
                                    !lineoutEvents.includes(startReason) && (
                                        <span>{secondsToTime(clipStartTime)}</span>
                                    )}
                                {clipState == ClipState.EndClipAndSelectPosition && (
                                    <span>{secondsToTime(clipEndTime)}</span>
                                )}
                                {((clipState == ClipState.StartClipAndSelectPosition &&
                                        !isScrumClipEnd &&
                                        !isLineoutClipEnd &&
                                        startReason !== MatchEvents.ShotAtGoalConversion &&
                                        startReason !== MatchEvents.ShotAtGoalPenalty) ||
                                    (clipState == ClipState.EndClipAndSelectPosition &&
                                        endReason !== MatchEvents.Try)) && (
                                    <>
                                        <Button
                                            className="ml-1"
                                            variant="outline-primary"
                                            size="md"
                                            disabled={
                                                endReason === MatchEvents.Penalty &&
                                                clipState == ClipState.EndClipAndSelectPosition &&
                                                !penaltyReason
                                                    ? true
                                                    : false
                                            }
                                            onClick={async (e) => {
                                                await handleClipActionClick();
                                            }}
                                        >
                                            {clipState == ClipState.StartClipAndSelectPosition
                                                ? "Confirm Start Position"
                                                : "Confirm End Position"}
                                        </Button>
                                        <Button
                                            className="ml-1"
                                            variant="outline-danger"
                                            size="md"
                                            onClick={async (e) => {
                                                await onCancelClipButtonClick();
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </>
                                )}
                            </>
                        )}

                        {isLineoutClipEnd && (
                            <>
                                <Button
                                    className="ml-1"
                                    variant="outline-primary"
                                    size="md"
                                    disabled={
                                        isWon !== null && lineoutTarget !== null ? false : true
                                    }
                                    onClick={async () => {
                                        await handleConfirmLineout();
                                    }}
                                >
                                    Confirm lineout
                                </Button>

                                <Button
                                    className="ml-1"
                                    variant="outline-danger"
                                    size="md"
                                    onClick={async () => {
                                        await onCancelClipButtonClick();
                                    }}
                                >
                                    Cancel
                                </Button>
                            </>
                        )}

                        {isScrumClipEnd && (
                            <>
                                <Button
                                    className="ml-1"
                                    variant="outline-primary"
                                    size="md"
                                    disabled={isWon !== null ? false : true}
                                    onClick={async () => {
                                        await handleConfirmScrum();
                                    }}
                                >
                                    Confirm Scrum
                                </Button>

                                <Button
                                    className="ml-1"
                                    variant="outline-danger"
                                    size="md"
                                    onClick={async () => {
                                        await onCancelClipButtonClick();
                                    }}
                                >
                                    Cancel
                                </Button>
                            </>
                        )}

                        {Object.keys(clipSelected).length > 0 &&
                            ((clipSelected.type === ScoringInputType.ClipEnd &&
                                    clipSelected.clipEndReason !== MatchEvents.Try &&
                                    clipSelected.clipEndReason !== MatchEvents.Penalty) ||
                                (clipSelected.type === ScoringInputType.ClipStart &&
                                    !lineoutEvents.includes(clipSelected.clipStartReason) &&
                                    clipSelected.clipStartReason !== MatchEvents.Scrum)) && (
                                <>
                                    <Button
                                        className="ml-1"
                                        variant="outline-primary"
                                        size="md"
                                        onClick={async (e) => {
                                            await setClip(
                                                clipSelected.id,
                                                realMarkerX,
                                                realMarkerY,
                                                clipSelected.type,
                                                clipSelected.teamId,
                                            );
                                        }}
                                    >
                                        Confirm update clip
                                    </Button>

                                    <Button
                                        className="ml-1"
                                        variant="outline-danger"
                                        size="md"
                                        onClick={async (e) => {
                                            setClipSelected({});
                                            setRealMarkerX({});
                                            setRealMarkerY({});
                                            setPenaltyReason(null);
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </>
                            )}

                        {clipState == ClipState.StartClipAndSelectPosition &&
                            startReason == MatchEvents.Kickoff && (
                                <>
                                    {clipState == ClipState.StartClipAndSelectPosition && (
                                        <span>{secondsToTime(clipStartTime)}</span>
                                    )}
                                    <Button
                                        className="ml-1"
                                        variant="outline-primary"
                                        size="md"
                                        onClick={async (e) => {
                                            await handleClipActionClick();
                                        }}
                                    >
                                        Confirm Kickoff
                                    </Button>
                                    <Button
                                        className="ml-1"
                                        variant="outline-danger"
                                        size="md"
                                        onClick={async (e) => {
                                            setShowMultipleSelectedButton(true);
                                            setActiveClipState(videoTime);
                                            setClipStartTime(-1);
                                            setStartReason(null);
                                            setStartTeam(null);
                                        }}
                                    >
                                        Cancel Kickoff
                                    </Button>
                                </>
                            )}
                    </div>

                    <Row>
                        <PlayerUpdateList
                            selectedPlayer={selectedPlayer}
                            selectedScore={selectedScore}
                            isMultipleChoiceForPlayer={isMultipleChoiceForPlayer}
                            setSelectedEditPlayer={setSelectedEditPlayer}
                            selectedMultipleString={selectedMultipleString}
                            selectedString={selectedString}
                            selectedEditPlayer={selectedEditPlayer}
                            homeTeamPlayers={homeTeamPlayers}
                            awayTeamPlayers={awayTeamPlayers}
                            inputItemList={inputItemList}
                        />
                    </Row>
                    <Row>
                        <Col>
                            {selectedPlayer?.categorizations ? (
                                <Button
                                    variant="outline-danger"
                                    className="ml-2"
                                    size="sm"
                                    onClick={() => {
                                        setSelectedScore(null);
                                        setIsScoresListEmpty(true);
                                    }}
                                >
                                    Clear Score
                                </Button>
                            ) : (
                                <></>
                            )}
                            {selectedPlayer?.categorizations &&
                            (Object.keys(selectedCategories).length > 0 ||
                                (Object.keys(selectedDescription || {}).length >= 0 &&
                                    isDescriptionListEmpty) ||
                                selectedScore ||
                                (realMarkerX !== null && !realMarkerY !== null) ||
                                selectedEditPlayer) ? (
                                <Button
                                    variant="outline-success"
                                    className="ml-2"
                                    size="sm"
                                    onClick={async (e) => {
                                        showLoader();
                                        const playerUpdate = selectedEditPlayer ?? selectedPlayer.shirtNumber;
                                        const isTeamScore = homeTeamPlayers?.[0]?.id == playerUpdate ||  awayTeamPlayers?.[0]?.id == playerUpdate;

                                        await setPlayerScore(
                                            selectedPlayer.id,
                                            selectedPlayer.teamId,
                                            playerUpdate,
                                            selectedPlayer.positionX,
                                            selectedPlayer.positionY,
                                            selectedPlayer.totalScore
                                                ? selectedPlayer.totalScore
                                                : selectedPlayer.score,
                                            selectedPlayer.categorizations?.reduce(
                                                (r, {scoreCategoryId, value}) => (
                                                    (r[scoreCategoryId] = value), r
                                                ),
                                                {}
                                            ),
                                            null,
                                            isTeamScore
                                        );
                                        setIsScoresListEmpty(false);
                                        setIsCategoriesListEmpty(false);
                                        setIsDescriptionListEmpty(false);
                                        setSelectedScore(null);
                                        setSelectedCategories({});
                                        setSelectedDescription([]);
                                        setSelectedPlayer(null);
                                        setSelectedEditPlayer(null);
                                        hideLoader();
                                    }}
                                >
                                    Confirm
                                </Button>
                            ) : (
                                <></>
                            )}

                            {(selectedPlayer || isConfirmMultipleChoice) && (
                                <Button
                                    className="ml-1 float-left"
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={async (e) => {
                                        if (isConfirmMultipleChoice) {
                                            setSelectedPlayersTeam({});
                                            setIsMultipleChoiceForPlayer((current) => !current);
                                            setSelectedPlayers([]);
                                            setIsMultipleChoiceColor(false);
                                            setIsConfirmMultipleChoice(false);
                                        }
                                        setInputTime(
                                            inputItemList.filter(
                                                (x) => x.id === selectedPlayer?.id
                                            )[0]?.time
                                        );
                                        setSelectedPlayer(null);
                                        setSelectedScore(null);
                                        setRealMarkerX(null);
                                        setRealMarkerY(null);
                                        setSelectedCategories({});
                                        setDropgoalSelected(false);
                                        setIsCategoriesListEmpty(false);
                                        setIsDescriptionListEmpty(false);
                                        setIsScoresListEmpty(false);
                                        setSelectedDescription([]);
                                        setSelectedEditPlayer(null);
                                    }}
                                >
                                    Cancel Score
                                </Button>
                            )}

                            {(selectedPlayer || isConfirmMultipleChoice) &&
                                selectedScore &&
                                Object.keys(selectedCategories).length > 0 &&
                                realMarkerX !== null &&
                                !realMarkerY !== null &&
                                !selectedPlayer?.categorizations && (
                                    <Button
                                        className="float-left ml-2"
                                        variant="outline-success"
                                        size="sm"
                                        onClick={async (e) => {
                                            if (selectedPlayer && selectedScore) {
                                                setInputTime(videoTime);
                                                if (selectedPlayer.position == -1) {
                                                    saveTeamScore(
                                                        fixtureRoomId,
                                                        selectedPlayer.teamId,
                                                        selectedPlayer.position,
                                                        selectedScore.value,
                                                        selectedCategories,
                                                        selectedDescription,
                                                    );
                                                } else {
                                                    savePlayerScore(
                                                        fixtureRoomId,
                                                        selectedPlayer.teamId,
                                                        selectedPlayer.position,
                                                        selectedScore.value,
                                                        selectedCategories,
                                                        selectedDescription,
                                                    );
                                                }
                                            } else if (isConfirmMultipleChoice) {
                                                savePlayerScoreGroup(
                                                    fixtureRoomId,
                                                    selectedPlayers,
                                                    selectedScore.value,
                                                    selectedCategories,
                                                    selectedDescription,
                                                    videoTime
                                                );

                                                setIsMultipleChoiceForPlayer((current) => !current);
                                                setSelectedPlayers([]);
                                                setIsMultipleChoiceColor(false);
                                                setIsConfirmMultipleChoice(false);
                                            }
                                            if (selectedPlayer?.isYellowCard) {
                                                showLoader();
                                                hideLoader();
                                            }
                                            setInputTime(videoTime);
                                            setSelectedPlayer(null);
                                            setSelectedScore(null);
                                            setRealMarkerX(null);
                                            setSelectedPlayersTeam({});
                                            setRealMarkerY(null);
                                            setIsCategoriesListEmpty(false);
                                            setIsDescriptionListEmpty(false);
                                            setIsScoresListEmpty(false);
                                            setSelectedCategories({});
                                            setSelectedDescription([]);
                                        }}
                                    >
                                        Add
                                    </Button>
                                )}
                        </Col>
                        <Col>
                            {(selectedPlayer || isConfirmMultipleChoice) && (
                                <Button
                                    className="float-right"
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={async (e) => {
                                        await setIsCategoriesListEmpty(true);
                                        await setSelectedCategories({});
                                    }}
                                >
                                    Clear Categorisations
                                </Button>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        {(selectedPlayer ||
                            Object.keys(clipSelected).length > 0 ||
                            isConfirmMultipleChoice) && (
                            <CategorizationBar
                                categoriesList={categoriesList}
                                selectedCategories={
                                    !selectedPlayer?.categorizations ||
                                    selectedPlayers.length > 0 ||
                                    Object.keys(selectedCategories).length > 0 ||
                                    isCategoriesListEmpty
                                        ? selectedCategories
                                        : selectedPlayer.categorizations?.reduce(
                                            (r, {scoreCategoryId, value}) => (
                                                (r[scoreCategoryId] = value), r
                                            ),
                                            {}
                                        )
                                }
                                setSelectedCategories={setSelectedCategories}
                            />
                        )}
                    </Row>
                    <Row>
                        <MultiplePlayersBar
                            homeTeamPlayers={homeTeamPlayers}
                            awayTeamPlayers={awayTeamPlayers}
                            selectedPlayers={selectedPlayers}
                            setSelectedPlayers={setSelectedPlayers}
                            selectedPlayersTeam={selectedPlayersTeam}
                            setSelectedPlayersTeam={setSelectedPlayersTeam}
                            setIsConfirmMultipleChoice={setIsConfirmMultipleChoice}
                        />
                    </Row>
                    {clipState == ClipState.StartClipAndSelectPosition &&
                        startReason == MatchEvents.ShotAtGoalPenalty && (
                            <PenaltyShotAtGoal
                                fixtureRoomId={fixtureRoomId}
                                homeTeam={fixtureDetails.homeTeam}
                                awayTeam={fixtureDetails.awayTeam}
                                startTeamId={startTeam}
                                homeTeamPlayers={homeTeamPlayers}
                                awayTeamPlayers={awayTeamPlayers}
                                realMarkerX={previousClipEndXCoordinate()}
                                realMarkerY={previousClipEndYCoordinate()}
                                videoTime={videoTime}
                                clipStartTime={clipStartTime}
                                setShowMultipleSelectedButton={setShowMultipleSelectedButton}
                                onCancelButtonClick={onCancelClipButtonClick}
                            />
                        )}

                    {dropgoalSelected && (
                        <Dropgoal
                            fixtureRoomId={fixtureRoomId}
                            homeTeam={fixtureDetails.homeTeam}
                            awayTeam={fixtureDetails.awayTeam}
                            startTeamId={selectedPlayer.teamId}
                            realMarkerX={realMarkerX}
                            realMarkerY={realMarkerY}
                            videoTime={videoTime}
                            clipStartTime={clipStartTime}
                            half={currentHalfState}
                            dropgoalKicker={selectedPlayer}
                            clipId={currentClipId}
                            onDropgoalResult={onComponentClose}
                            displayKickInfo={displayKickInfo}
                        />
                    )}

                    {clipState == ClipState.StartClipAndSelectPosition &&
                        startReason == MatchEvents.ShotAtGoalConversion && (
                            <ConversionShotAtGoal
                                fixtureRoomId={fixtureRoomId}
                                homeTeam={fixtureDetails.homeTeam}
                                awayTeam={fixtureDetails.awayTeam}
                                startTeamId={startTeam}
                                homeTeamPlayers={homeTeamPlayers}
                                awayTeamPlayers={awayTeamPlayers}
                                realMarkerY={realMarkerY}
                                realMarkerX={realMarkerX}
                                videoTime={videoTime}
                                clipStartTime={clipStartTime}
                                half={currentHalfState}
                                onConversionResult={onComponentClose}
                                setShowMultipleSelectedButton={setShowMultipleSelectedButton}
                                onCancelButtonClick={onCancelClipButtonClick}
                            />
                        )}

                    {Object.keys(clipSelected).length > 0 &&
                        clipSelected.clipEndReason === MatchEvents.Try &&
                        clipSelected.type === ScoringInputType.ClipEnd && (
                            <ConversionOrPenaltySetClip
                                homeTeam={fixtureDetails.homeTeam}
                                awayTeam={fixtureDetails.awayTeam}
                                startTeamId={clipSelected?.teamId}
                                homeTeamPlayers={homeTeamPlayers}
                                awayTeamPlayers={awayTeamPlayers}
                                onCancelButtonClick={onCancelClipButtonClick}
                                realMarkerY={realMarkerY}
                                realMarkerX={realMarkerX}
                                clipSelected={clipSelected}
                                setClip={setClip}
                            />
                        )}

                    {Object.keys(clipSelected).length > 0 &&
                        lineoutEvents.includes(clipSelected.clipStartReason) &&
                        clipSelected.type === ScoringInputType.ClipStart && (
                            <LineOutInfoUpdate
                                onCancelClipButtonClick={onCancelClipButtonClick}
                                isWon={isWon}
                                setIsWon={setIsWon}
                                lineoutTarget={lineoutTarget}
                                setLineoutTarget={setLineoutTarget}
                                isFreekick={isFreekick}
                                setIsFreekick={setIsFreekick}
                                realMarkerY={realMarkerY}
                                realMarkerX={realMarkerX}
                                clipSelected={clipSelected}
                                setClip={setClip}
                            />
                        )}

                    {clipState == ClipState.StartClipAndSelectPosition &&
                        isLineoutClipEnd && (
                            <LineOutInfo
                                isWon={isWon}
                                setIsWon={setIsWon}
                                lineoutTarget={lineoutTarget}
                                setLineoutTarget={setLineoutTarget}
                                isFreekick={isFreekick}
                                setIsFreekick={setIsFreekick}
                            />
                        )}

                    {Object.keys(clipSelected).length > 0 &&
                        clipSelected.clipStartReason == MatchEvents.Scrum &&
                        clipSelected.type === ScoringInputType.ClipStart && (
                            <ScrumInfoUpdate
                                onCancelClipButtonClick={onCancelClipButtonClick}
                                isWon={isWon}
                                setIsWon={setIsWon}
                                isScrumPenalty={isScrumPenalty}
                                setIsScrumPenalty={setIsScrumPenalty}
                                isFreekick={isFreekick}
                                setIsFreekick={setIsFreekick}
                                realMarkerY={realMarkerY}
                                realMarkerX={realMarkerX}
                                clipSelected={clipSelected}
                                setClip={setClip}
                            />
                        )}

                    {clipState == ClipState.StartClipAndSelectPosition &&
                        isScrumClipEnd && (
                            <ScrumInfo
                                isWon={isWon}
                                setIsWon={setIsWon}
                                isScrumPenalty={isScrumPenalty}
                                setIsScrumPenalty={setIsScrumPenalty}
                                isFreekick={isFreekick}
                                setIsFreekick={setIsFreekick}
                            />
                        )}

                    {endReason == MatchEvents.Penalty && (
                        <ClipEndPenaltyInfo
                            penaltyReason={penaltyReason}
                            setPenaltyReason={setPenaltyReason}
                        />
                    )}

                    {Object.keys(clipSelected).length > 0 &&
                        clipSelected.clipEndReason == MatchEvents.Penalty &&
                        clipSelected.type === ScoringInputType.ClipEnd && (
                            <ClipEndPenaltyInfoUpdate
                                penaltyReason={penaltyReason}
                                setPenaltyReason={setPenaltyReason}
                                clipSelected={clipSelected}
                                setClip={setClip}
                                realMarkerY={realMarkerY}
                                realMarkerX={realMarkerX}
                                onCancelClipButtonClick={onCancelClipButtonClick}
                            />
                        )}

                    {clipState == ClipState.EndClipAndSelectPosition &&
                        endReason == MatchEvents.Try && (
                            <TryScore
                                fixtureRoomId={fixtureRoomId}
                                homeTeam={fixtureDetails.homeTeam}
                                awayTeam={fixtureDetails.awayTeam}
                                endTeamId={endTeam}
                                homeTeamPlayers={homeTeamPlayers}
                                awayTeamPlayers={awayTeamPlayers}
                                realMarkerX={realMarkerX}
                                realMarkerY={realMarkerY}
                                videoTime={videoTime}
                                onCancelButtonClick={onCancelClipButtonClick}
                                startClipId={currentClipId}
                                setShowMultipleSelectedButton={setShowMultipleSelectedButton}
                                onTryScoreResult={onComponentClose}
                                setEndReason={setEndReason}
                            />
                        )}

                    {!(
                            (clipState == ClipState.StartClipAndSelectPosition &&
                                (startReason == MatchEvents.ShotAtGoalPenalty ||
                                    startReason == MatchEvents.ShotAtGoalConversion)) ||
                            (clipState == ClipState.EndClipAndSelectPosition &&
                                endReason == MatchEvents.Try)
                        ) &&
                        !dropgoalSelected && (
                            <Row className="pl-2">
                                {!(
                                    selectedPlayer ||
                                    Object.keys(clipSelected).length > 0 ||
                                    isConfirmMultipleChoice
                                ) && (
                                    <TeamScoringControls
                                        fixtureDetails={fixtureDetails}
                                        homeTeamPlayers={homeTeamPlayers}
                                        awayTeamPlayers={awayTeamPlayers}
                                        selectedPlayer={selectedPlayer}
                                        setSelectedPlayer={setSelectedPlayer}
                                        setSelectedScore={setSelectedScore}
                                        isMultipleChoiceForPlayer={isMultipleChoiceForPlayer}
                                        isMultipleChoiceColor={isMultipleChoiceColor}
                                        setIsMultipleChoiceColor={setIsMultipleChoiceColor}
                                        selectedPlayers={selectedPlayers}
                                        setSelectedPlayers={setSelectedPlayers}
                                        onShowWatcherCardsMessageModal={
                                            onShowWatcherCardsMessageModal
                                        }
                                        setSelectedPlayersTeam={setSelectedPlayersTeam}
                                        selectedPlayersTeam={selectedPlayersTeam}
                                        isConfirmStartEnd={
                                            clipState == ClipState.StartClipAndSelectPosition ||
                                            clipState == ClipState.EndClipAndSelectPosition
                                        }
                                    />
                                )}
                                {(selectedPlayer || isConfirmMultipleChoice) && (
                                    <ValueScoringControls
                                        selectedScore={
                                            selectedScore ||
                                            selectedPlayer?.currentScore === 0 ||
                                            selectedPlayers.length > 0 ||
                                            isScoresListEmpty
                                                ? selectedScore
                                                : selectedPlayer?.totalScore
                                                    ? {
                                                        ...selectedPlayer.totalScore,
                                                        key: selectedPlayer.totalScoreText,
                                                        value: selectedPlayer.totalScore,
                                                    }
                                                    : {
                                                        ...selectedPlayer.currentScore,
                                                        key: selectedPlayer.scoreText,
                                                        value: selectedPlayer.currentScore,
                                                    }
                                        }
                                        setSelectedScore={setSelectedScore}
                                    />
                                )}
                                {(selectedPlayer || isConfirmMultipleChoice) && (
                                    <CategorizationScoringControls
                                        descriptionOptions={descriptionOptions}
                                        categoriesList={categoriesList}
                                        selectedCategories={
                                            !selectedPlayer?.categorizations ||
                                            selectedPlayers.length > 0 ||
                                            Object.keys(selectedCategories).length > 0 ||
                                            isCategoriesListEmpty
                                                ? selectedCategories
                                                : selectedPlayer.categorizations?.reduce(
                                                    (r, {scoreCategoryId, value}) => (
                                                        (r[scoreCategoryId] = value), r
                                                    ),
                                                    {}
                                                )
                                        }
                                        setSelectedCategories={setSelectedCategories}
                                        selectedDescription={
                                            !selectedPlayer?.playerScoreDescriptions ||
                                            selectedPlayers.length > 0 ||
                                            Object.keys(selectedDescription || {}).length > 0 ||
                                            isDescriptionListEmpty
                                                ? selectedDescription
                                                : selectedPlayer.playerScoreDescriptions
                                        }
                                        setSelectedDescription={setSelectedDescription}
                                        setIsDescriptionListEmpty={setIsDescriptionListEmpty}
                                    />
                                )}
                            </Row>
                        )}
                </Col>
                <Col lg="8" style={{height: "calc(100vh - 65px)"}}>
                    <Row>
                        <Col>
                            {scoreErrorMessageSpan}
                            {infoMessageSpan}
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="2" md="0"></Col>
                        <Col lg="8" md="12" ref={videoWrapperRef}>
                            {videoControls}
                        </Col>
                        <Col></Col>
                    </Row>
                    <Row className="pt-1">
                        <Col>
                            {((clipState == ClipState.StartClipAndSelectPosition &&
                                    startReason !== MatchEvents.Kickoff &&
                                    startReason != MatchEvents.ShotAtGoalPenalty) ||
                                clipState == ClipState.EndClipAndSelectPosition ||
                                selectedPlayer ||
                                Object.keys(clipSelected).length > 0 ||
                                isConfirmMultipleChoice) && (
                                <div className="px-2">
                                    {previousClipEnd()?.endTeam &&
                                    previousClipEnd().clipEndReason !==
                                    MatchEvents.ShotAtGoalPenaltyMiss &&
                                    !(
                                        selectedPlayer ||
                                        Object.keys(clipSelected).length > 0 ||
                                        isConfirmMultipleChoice
                                    ) &&
                                    !isStartSettingClipEnd ? (
                                        <></>
                                    ) : (
                                        <PitchView
                                            onRealMarkerXChange={handleRealMarkerX}
                                            onRealMarkerYChange={handleRealMarkerY}
                                            isHomeTeamLeft={
                                                fixtureDetails && currentTeamAtOrigin
                                                    ? currentTeamAtOrigin == fixtureDetails.homeTeam.id
                                                    : null
                                            }
                                            startReason={startReason}
                                            endReason={endReason}
                                            clipState={clipState}
                                            startTeamId={startTeam}
                                            endTeamId={endTeam}
                                            homeTeamId={fixtureDetails.homeTeam.id}
                                            previousClipYCoordinate={previousClipEndYCoordinate()}
                                            selectedPlayer={selectedPlayer}
                                            previousCoordinates={getPreviousXAndYCoordinates}
                                            clipSelected={clipSelected}
                                            firstCurrentAtOrigin={
                                                fixtureDetails?.firstHalfTeamAtOrigin
                                            }
                                            secondCurrentAtOrigin={
                                                fixtureDetails?.secondHalfTeamAtOrigin
                                            }
                                            firstHalfStart={fixtureDetails?.firstHalfStart}
                                            secondHalfStart={fixtureDetails?.secondHalfStart}
                                        ></PitchView>
                                    )}
                                </div>
                            )}

                            {clipState != ClipState.StartClipAndSelectPosition &&
                                clipState != ClipState.EndClipAndSelectPosition &&
                                !(
                                    selectedPlayer ||
                                    isConfirmMultipleChoice ||
                                    Object.keys(clipSelected).length > 0
                                ) && (
                                    <InputTable
                                        height={`calc(100vh - ${inputTableHeightOffset}px)`}
                                        errorIds={errorInputIds}
                                        inputItemList={inputItemList}
                                        deleteAction={deleteAction}
                                        fixtureRoomId={fixtureRoomId}
                                        jumpVideoPlayer={(time) =>
                                            videoJsRef.current.setVideoTime(time)
                                        }
                                        time={inputTime}
                                        onFlagClick={onFlagClick}
                                        setIsCardHighlighted={setIsCardHighlighted}
                                        getCurrentTime={getCurrentTime}
                                        setScoreErrorMessages={setScoreErrorMessages}
                                        videoTime={videoTime}
                                        setSelectedPlayer={setSelectedPlayer}
                                        showScoringInputDetailModal={showScoringInputDetailModal}
                                        setScoringInputDetailModal={setScoringInputDetailModal}
                                        setInfoMessages={setInfoMessages}
                                        setClipSelected={setClipSelected}
                                    ></InputTable>
                                )}
                        </Col>
                    </Row>
                </Col>
            </Row>
            {loader}
            {matchEndModal}
            {missingVideoModal}
            {teamPitchPositionModal}
            {flagModal}
            {watcherCardsMessageModal}
            {FutureFixturePopupModal}
            {playerDetailsModal}
        </div>
    );
};

Scoring.displayName = Scoring.name;

export default Scoring;
